import _, { set } from "lodash";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  shareImage,
  boardcastDataResponse,
  calendarLiveEventSaved,
  cancelSessionData,
  cancelSessionDataClear,
  getCalendarSessionList,
  getCalendarSessionListClear,
  getEnrollAvailability,
  getEnrollAvailabilityClear,
  getEnrollBrokerSession,
  hostSession,
  joinSession,
  sessionWatchURLDataClear,
  sessionWatchURLDataResponse,
  syncSessionReq,
  syncSessionResponseClear,
  shareImageResponseClear,
  getLiveSessionList,
  getLiveSessionListClear,
} from "../../redux/events/actions";
import {
  SessionKeys,
  abortAllRequests,
  capitalizeFirstLetter,
  clickStreamUser,
  convertTimeFormat,
  getNumberOfWeeksInMonth,
  getProcureInfo,
  isInCurrentMonth,
  timezoneArea,
} from "../../utils/AppUtils";
import {
  getSmartBar,
  homePageMsg,
  homePageShowMsg,
} from "../../redux/home/actions";
import RenderButtonForCalendar from "../Home/RenderButtonForCalender";
import { useNavigate } from "react-router-dom";
import EventSessionDetailComponent from "./EventSessionDetailComponent";
import Loader from "../Loader/Loader";
import html2canvas from "html2canvas";
import $ from "jquery";
import { FacebookShareButton, LinkedinShareButton } from "react-share";
import EventCalendarTabsComponent from "./EventCalendarTabsComponent";
import CONFIG from "../../utils/config";
import ConfirmModal from "../modal/ConfirmModal";
import jsPDF from "jspdf";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { Spinner } from "react-bootstrap";
import { UI } from "@pdftron/webviewer";
import ShimmerCardBody from "../Layouts/ShimmerCardBody";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import ShimmerNotification from "../Layouts/ShimmerNotification";
import CartPopUpComponent from "../NewDesign/DetailPage/CartPopUp/CartPopUpComponent";
import useLogin from "../../custom-hooks/useLogin";
import EventSliderFilterSection from "../NewDesign/Event/EventSliderFilter";
import { useTranslation } from "react-i18next";
import SlotBookingModal from "../NewDesign/Halifax/Coaching/SlotBookingModal";
import Modal from "react-bootstrap/Modal";
import BookingCongratsModal from "../NewDesign/Halifax/Coaching/BookingCongratsModal";
import Four8HourRescheduleModal from "../NewDesign/Halifax/Coaching/Four8HourRescheduleModal";
const EventsCalendar = (props) => {
  const {
    isHome,
    isLearn,
    marketingDateRange,
    setSelectedSessionFromHome,
    selectedSessionPos,
    setSelectedSessionPos,
    weekHeader,
    currentWeekStartFromHome,
    mySession,
    isLive,
    fromPartner,
    isMobile,
    isEvents,
    isCoaching,
    isMyCoaching,
  } = props;

  const { t } = useTranslation();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  let uId = params.get("uid");
  let id = params.get("id");
  const isGuest = params.get("guest");
  const sIdParam = params.get("s_id");
  const c = params.get("c");
  let providerId = "";
  let allPartners = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    providerId = paramsReq.provider_id;
    allPartners = paramsReq?.allPartners;
  }
  const [selectedPartner, setSelectedPartner] = useState(
    providerId ? "" : "all"
  );
  const { isLoggedIn } = useLogin();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const calenderSessionListArray = useSelector(
    (state) => state.events.calendarSessionList
  );
  const liveSessionsResponse = useSelector(
    (state) => state.events.liveSessionsData
  );
  const enrollAvailability = useSelector(
    (state) => state.events.enrollAvailability
  );
  const authBroker = useSelector((state) => state.auth.authBroker);
  const joinSessionData = useSelector((state) => state.events.joinSession);
  const addToCartRes = useSelector((state) => state.product.addToCart);
  const hostSessionInfo = useSelector((state) => state.events.hostSession);
  const enrollBrokerSession = useSelector(
    (state) => state.events.enrollBrokerSession
  );
  const attendence = useSelector(
    (state) => state.events.sessionAttendenceMarked
  );
  const sessionCancelledData = useSelector(
    (state) => state.events.sessionCancel
  );
  const showHomePageMsg = useSelector((state) => state.home.showHomePageMsg);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userRole = useSelector((state) => state.user.role);
  const timezoneAbbr = useSelector((state) => state.user.timezoneAbbr);

  const imageUrlRes = useSelector((state) => state.events.shareImageRes);

  const syncSessionRes = useSelector((state) => state.events.syncSessionRes);

  const [calendarInterval, setCalendarInterval] = useState(null);
  const [sessionCalList, setSessionCalList] = useState({});
  const [fetchData, setFetchData] = useState(false);
  const [myEvents, setMyEvents] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [isConfirm, setIsConfirm] = useState(true);
  const [showModalMsg, setShowModalMsg] = useState(
    "Would you like to unregister from the session?"
  );
  const [showLoader, setShowLoader] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [zoneAbbr, setZoneAbbr] = useState("CDT");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [sessionDataForModal, setSessionDataForModal] = useState({});
  const [selectedSession, setSelectedSession] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [allShareClicked, setAllShareClicked] = useState(false);
  const currentRef = useRef(null);
  const [imageUrl, setimageUrl] = useState();
  const [pdfUrl, setPdfUrl] = useState();
  const [currentMonth, setCurrentMonth] = useState(0);
  const [monthHeader, setMonthHeader] = useState("Prev - Next");
  const [weeksCount, setWeeksCount] = useState(0);
  const [fbTagetUrl, setfbTagetUrl] = useState();
  const [linkedinTargetUrl, setlinkedinTargetUrl] = useState();
  const [selectedTab, setSelectedTab] = useState("monthView");
  const [startDateRange, setStartDateRange] = useState("");
  const [endDateRange, setEndDateRange] = useState("");
  const [selectedTabWeek, setSelectedTabWeek] = useState("");

  const [shareClicked, setShareClicked] = useState(true);
  const [clickedShareBtn, setClickedShareBtn] = useState(0);
  const [googleSync, setGoogleSync] = useState(false);
  const [isSyncLoading, setIsSyncLaoding] = useState(true);
  const [clickedItem, setClickedItem] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [headerProdData, setHeaderProdData] = useState({});
  const [clickDetailShareBtn, setClickDetailShareBtn] = useState(false);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);

  const [rescheduleMode, setRescheduleMode] = useState(false);
  const [sessionModal, setSessionModal] = useState(false);
  const [selectedCoachId, setSelectedCoachId] = useState("");
  const [productTitle, setProductTitle] = useState("");
  const [productId, setProductId] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [rescheduleFlag, setRescheduleFlag] = useState(false);
  const [show, setShow] = useState(false);
const [congratsModal, setCongratsModal] = useState(false);
const [sessionId, setSessionId] = useState("");
const [selectedHour,setSelectedHour] = useState(4);
const [show4HourRescheduleModal, setShow4HourRescheduleModal] = useState(false);

  const handleClose = () => setShow(false);
  const openSlotModalBooking = () => {
    console.log("SlotModalBooking should open now!");
    setSessionModal(true);
    setRescheduleFlag(true);
    setShow(true);
  };

  const handleReschedule = (productid, coachid, sessionId,hours) => {
    console.log("coachid", coachid);
    setSelectedCoachId(coachid);
    setProductId(productid);
    setSessionId(sessionId);
    setShowModalMsg("Are you sure you want to Reschedule this session?");
    setConfirmModal(true);
    setIsConfirm(true);
    setSelectedHour(hours);
    if(hours===4 || hours===8){
      setClickedItem(4); // Activate 4-8 hour reschedule flow
    }else{
     setClickedItem(3); // Activate reschedule flow
    }
  };

  function getNextSixMonthsDate() {
    let currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 6);

    let month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    let day = currentDate.getDate().toString().padStart(2, "0");
    let year = currentDate.getFullYear();

    return `${month}/${day}/${year}`;
  }

  function formatDate() {
    let currentDate = new Date();
    let month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    let day = currentDate.getDate().toString().padStart(2, "0");
    let year = currentDate.getFullYear();

    return `${month}/${day}/${year}`;
  }

  useEffect(() => {
    console.log("isLoading", isLoading);
  }, [isLoading]);

  useEffect(() => {
    console.log("isGuest", isGuest);

    dispatch(
      getSmartBar({
        module: "getSmartBar",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
        },
      })
    );
    if (isGuest && uId) {
      return;
      let date_range = {
        start_date: formatDate(),
        end_date: getNextSixMonthsDate(),
      };
      setIsLoading(true);

      let uid = atob(uId);

      dispatch(
        getCalendarSessionList({
          module: "calendarSessionListEcom",
          postData: {
            token: "",
            email: "",
            user_id: uid,
            company_id: "",
            date_range,
            language: activeLanguage ? activeLanguage : "",
          },
        })
      );
    }
  }, [uId]);

  useEffect(() => {
    let localDate = moment().startOf("month").clone().add(0, "M").startOf("M");
    let startDate = localDate.format("MMMM, YYYY");
    if (isGuest !== "true") {
      setMonthHeader(startDate);
    }
    syncSessionFunc("check");
    return () => {
      abortAllRequests();
      dispatch(syncSessionResponseClear());
      dispatch(homePageMsg(""));
      dispatch(homePageShowMsg(false));
      // clearInterval(calendarInterval);
    };
  }, []);
  const syncSessionFunc = (type) => {
    if (isHome && isGuest) {
      return;
    }
    // setIsSyncLaoding(true);
    // dispatch(
    //   syncSessionReq({
    //     module: "getSyncSession",
    //     postData: {
    //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    //       google_sync: type,
    //     },
    //   })
    // );
  };

  useEffect(() => {
    console.log("sessionRes: ", syncSessionRes);
    if (!_.isEmpty(syncSessionRes)) {
      setIsSyncLaoding(false);
      if (syncSessionRes?.status === "success") {
        let response = syncSessionRes?.payload?.payload;
        if (response?.google_sync) {
          setGoogleSync(true);
        } else {
          if (googleSync) {
            setIsConfirm(false);
            setShowModalMsg("Sessions are synced successfully.");
            setConfirmModal(true);
          }
          setGoogleSync(false);
        }
      }
    }
  }, [syncSessionRes]);

  useEffect(() => {
    if (clickedShareBtn > 0) {
      getBlobForAllEvents();
    }
  }, [clickedShareBtn]);

  useEffect(() => {
    if (imageUrlRes?.status === "success" && allShareClicked) {
      console.log("respo", imageUrlRes);
      setfbTagetUrl(imageUrlRes?.payload?.payload?.fb_target_url);
      setlinkedinTargetUrl(imageUrlRes?.payload?.payload?.linkedin_target_url);
      setimageUrl(
        CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.data
      );
      setPdfUrl(
        CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.pdf_url
      );
      // setimageUrl(CONFIG.DOMAIN_URL + "shareImage?imageUrl=" + imageUrlRes?.payload?.payload);
      setIsLoading(false);

      let pdfUrl =
        CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.pdf_url;
      let imgUrl =
        CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.data;
      let fbUrl = imageUrlRes?.payload?.payload?.fb_target_url;
      let linkedInUrl = imageUrlRes?.payload?.payload?.linkedin_target_url;
      console.log("responseShare", clickedShareBtn);

      let shareUrl =
        clickedShareBtn === 1
          ? pdfUrl
          : clickedShareBtn === 2
          ? imgUrl
          : clickedShareBtn === 3
          ? fbUrl
          : clickedShareBtn === 4
          ? linkedInUrl
          : "";

      if (clickedShareBtn > 0) {
        window.open(shareUrl, "_blank");
        setClickedShareBtn(0);
        dispatch(shareImageResponseClear({}));
      }
    }
  }, [imageUrlRes, dispatch]);

  useEffect(() => {}, [imageUrl]);

  const getBlobForAllEvents = () => {
    console.log("shareJson: ", selectedSession);
    let reqArr = [];
    if (!clickDetailShareBtn) {
      for (let i = 0; i < events.length; i++) {
        const item = events[i];
        let tempObj = {
          dayName: moment(item?.start).format("ddd"),
          sessionDay: moment(item?.start).format("DD"),
          sessionMonth: moment(item?.start).format("MMM"),
          title: item?.title,
          sessionStarttime: moment(item?.start).format("h:mm A"),
          sessionMode: setDeliveryMode(item),
          thumbnail: item?.marketting_event_thumbnail,
          desc: item?.marketting_event_desc,
          banner: item?.marketting_event_banner,
        };
        reqArr.push(tempObj);

        if (clickedShareBtn > 2) {
          if (i === 8) {
            break;
          }
        }
      }
    } else {
      setClickDetailShareBtn(false);
      let tempObj = {
        dayName: moment(selectedSession?.start).format("ddd"),
        sessionDay: moment(selectedSession?.start).format("DD"),
        sessionMonth: moment(selectedSession?.start).format("MMM"),
        title: selectedSession?.title,
        sessionStarttime: moment(selectedSession?.start).format("h:mm A"),
        sessionMode: setDeliveryMode(selectedSession),
        thumbnail: selectedSession?.marketting_event_thumbnail,
        desc: selectedSession?.marketting_event_desc,
        banner: selectedSession?.marketting_event_banner,
        location: selectedSession?.location,
        timezone: selectedSession?.timezone,
        end_time: moment(selectedSession?.end).format("h:mm A"),
        instructor: selectedSession?.author,
      };
      reqArr.push(tempObj);
    }
    const htmlContent = currentRef.current.innerHTML;
    const currentDate = new Date();
    // Convert to epoch (Unix timestamp)
    const epochTime = Math.floor(currentDate.getTime() / 1000); // Divide by 1000 to get seconds
    const formattedTime = `${epochTime}`;
    let selectedTabValue = getTabValue(selectedTab);
    setAllShareClicked(true);
    setIsLoading(true);
    let selectedMonth = 0;
    if (isHome) {
      let endOfWeek = currentWeekStartFromHome
        .clone()
        .endOf("week")
        .format("MM/DD/YYYY");
      let month = Number(endOfWeek?.split("/")[0]);
      let currentMonth = new Date().getMonth() + 1;
      selectedMonth = month - currentMonth;
    }
    dispatch(
      shareImage({
        module: "shareImage",
        postData: {
          image_name: formattedTime,
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          content: reqArr,
          week_name: isHome ? weekHeader : monthHeader + selectedTabValue,
          page: isHome ? "home" : "main",
          tabType: isHome ? "monthView" : selectedTab,
          currentMonth: isHome ? selectedMonth : currentMonth,
          activeTabWeek: isHome ? "monthView" : selectedTabWeek,
          s_id: !clickDetailShareBtn ? "" : selectedSession.segmentId,
          action:
            clickedShareBtn === 1
              ? "pdf"
              : clickedShareBtn === 2
              ? "image"
              : clickedShareBtn === 3
              ? "fb"
              : "linkedin",
          session_type: clickDetailShareBtn ? "detail" : "list",
        },
      })
    );
  };

  const getTabValue = (tabType) => {
    if (tabType === "week1") {
      return " - Week 1";
    } else if (tabType === "week2") {
      return " - Week 2";
    } else if (tabType === "week3") {
      return " - Week 3";
    } else if (tabType === "week4") {
      return " - Week 4";
    } else if (tabType === "week5") {
      return " - Week 5";
    } else if (tabType === "week6") {
      return " - Week 6";
    } else if (tabType === "currentWeek") {
      return " - This Week";
    } else if (tabType === "today") {
      return " - Today";
    } else if (tabType === "tomorrow") {
      return " - Tomorrow";
    } else {
      return "";
    }
  };

  useEffect(() => {
    // console.log('userDetailRes: ', userDetailRes)
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      setUserDetails(userDetailRes?.payload?.payload);
    }
  }, [userDetailRes]);

  useEffect(() => {
    if (!confirmModal) {
      setShowLoader(false);
    }
  }, [confirmModal]);

  const range = (start, end) => {
    var arr = [];
    for (var i = start; i <= end; i++) arr.push(i);
    return arr;
  };

  const getTense = (diff) => {
    if (diff > 0) {
      return "future";
    } else if (diff < 0) {
      return "past";
    } else {
      return "present";
    }
  };

  const getTenseDiff = (value) => {
    if (value > 1) {
      return 1;
    } else if (value <= 0) {
      return -1;
    } else {
      return 0;
    }
  };

  // const events = formatEventsToWeekArray([sessionCalList.payload.sessionList])
  const [events, setEvents] = useState([]);
  const [currentWeekStart, setCurrentWeekStart] = useState(
    moment().startOf("week")
  );

  const formatWeekHeader = (weekStart) => {
    return (
      weekStart.format("YYYY, MMM DD - ") +
      weekStart.clone().add(1, "week").subtract(1, "days").format("MMM  DD")
    );
  };

  // const [weekHeader, setWeekHeader] = useState(
  //   formatWeekHeader(currentWeekStart)
  // );

  useEffect(() => {
    setShowLoader(!showHomePageMsg);
  }, [showHomePageMsg]);

  useEffect(() => {
    if (!_.isEmpty(authBroker) || true) {
      dispatch(sessionWatchURLDataClear());
      setFetchData(false);
      if (isHome && !_.isEmpty(marketingDateRange)) {
        getSessionsAccordingTab("monthView");
      }
    }
  }, [authBroker, marketingDateRange, currentWeekStartFromHome, isEvents]);

  useEffect(() => {
    if (isGuest !== "true") {
      getSessionsAccordingTab("monthView");
    }
  }, [selectedPartner, isLive, isGuest, isEvents]);

  const [fromGuestUser, setFromGuestUser] = useState(true);

  const getSessionsAccordingTab = (
    tabType,
    getMonth = currentMonth,
    tabTypeWeek = ""
  ) => {
    console.log("selectedTab: ", getMonth);
    setSelectedTab(tabType);
    setSelectedTabWeek(tabTypeWeek);
    // setShareClicked(false);
    let date_range = {};
    setSelectedSession({});
    if (isHome) {
      date_range = {
        start_date: currentWeekStartFromHome
          ?.clone()
          .add(-1, "d")
          .format("MM/DD/YYYY"),
        end_date: currentWeekStartFromHome
          ?.clone()
          .endOf("week")
          .clone()
          .add(1, "d")
          .format("MM/DD/YYYY"),
      };
      setStartDateRange(currentWeekStartFromHome?.clone().startOf("D"));
      setEndDateRange(
        currentWeekStartFromHome?.clone().endOf("week").clone().endOf("D")
      );
    } else {
      if (tabType === "currentWeek") {
        date_range = {
          start_date: currentWeekStart
            .clone()
            .add(-1, "d")
            .format("MM/DD/YYYY"),
          end_date: currentWeekStart
            .clone()
            .endOf("week")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY"),
        };
        setStartDateRange(currentWeekStart.clone().startOf("D"));
        setEndDateRange(
          currentWeekStart.clone().endOf("week").clone().endOf("D")
        );
        setMonthHeader(currentWeekStart.format("MMMM, YYYY"));
      } else if (tabType === "today") {
        let localDate = moment();
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate.clone().add(1, "d").format("MM/DD/YYYY"),
        };
        setStartDateRange(localDate.clone().startOf("D"));
        setEndDateRange(localDate.clone().endOf("D"));
        setMonthHeader(localDate.format("MMMM, YYYY"));
      } else if (tabType === "tomorrow") {
        let localDate = moment().add(1, "day");
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate.clone().add(1, "d").format("MM/DD/YYYY"),
        };
        setStartDateRange(localDate.clone().startOf("D"));
        setEndDateRange(localDate.clone().endOf("D"));
        setMonthHeader(localDate.format("MMMM, YYYY"));
      } else if (tabType === "monthView") {
        let localDate = moment()
          .startOf("month")
          .clone()
          .add(getMonth, "M")
          .startOf("M");
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate
            .clone()
            .endOf("month")
            .add(1, "d")
            .format("MM/DD/YYYY"),
        };
        let weeksCount = getNumberOfWeeksInMonth(
          localDate.year(),
          localDate.month()
        );
        setStartDateRange(localDate.clone().startOf("D"));
        setEndDateRange(localDate.clone().endOf("month").clone().endOf("D"));
        setWeeksCount(weeksCount);
        setMonthHeader(localDate.format("MMMM, YYYY"));
      } else if (tabType === "week1") {
        let localDate = moment()
          .startOf("month")
          .clone()
          .add(getMonth, "M")
          .startOf("M");
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate
            .clone()
            .clone()
            .endOf("week")
            .add(1, "d")
            .format("MM/DD/YYYY"),
        };
        let weeksCount = getNumberOfWeeksInMonth(
          localDate.year(),
          localDate.month()
        );
        setStartDateRange(localDate.clone().startOf("D"));
        setEndDateRange(localDate.clone().endOf("week").clone().endOf("D"));
        setWeeksCount(weeksCount);
        setMonthHeader(localDate.format("MMMM, YYYY"));
      } else if (tabType === "week2") {
        let localDate = moment()
          .startOf("month")
          .clone()
          .add(getMonth, "M")
          .startOf("M")
          .clone()
          .add(1, "week")
          .startOf("week");
        // let localDate = moment().startOf("month").clone().add(1, "week").startOf("week");
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate
            .clone()
            .endOf("week")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY"),
        };
        let weeksCount = getNumberOfWeeksInMonth(
          localDate.year(),
          localDate.month()
        );
        setWeeksCount(weeksCount);
        setStartDateRange(localDate.clone().startOf("D"));
        setEndDateRange(localDate.clone().endOf("week").clone().endOf("D"));
        setMonthHeader(localDate.format("MMMM, YYYY"));
      } else if (tabType === "week3") {
        let localDate = moment()
          .startOf("month")
          .clone()
          .add(getMonth, "M")
          .startOf("M")
          .clone()
          .add(2, "week")
          .startOf("week");
        // let localDate = moment().startOf("month").clone().add(2, "week").startOf("week");
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate
            .clone()
            .endOf("week")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY"),
        };
        let weeksCount = getNumberOfWeeksInMonth(
          localDate.year(),
          localDate.month()
        );
        setWeeksCount(weeksCount);
        setStartDateRange(localDate.clone().startOf("D"));
        setEndDateRange(localDate.clone().endOf("week").clone().endOf("D"));
        setMonthHeader(localDate.format("MMMM, YYYY"));
      } else if (tabType === "week4") {
        let localDate = moment()
          .startOf("month")
          .clone()
          .add(getMonth, "M")
          .startOf("M")
          .clone()
          .add(3, "week")
          .startOf("week");
        // let localDate = moment().startOf("month").clone().add(3, "week").startOf("week");
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate
            .clone()
            .endOf("week")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY"),
        };
        let weeksCount = getNumberOfWeeksInMonth(
          localDate.year(),
          localDate.month()
        );
        setWeeksCount(weeksCount);
        if (weeksCount === 4) {
          date_range.end_date = localDate
            .clone()
            .endOf("month")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY");
        }
        setStartDateRange(localDate.clone().startOf("D"));
        setEndDateRange(
          weeksCount === 4
            ? localDate.clone().endOf("month").clone().endOf("D")
            : localDate.clone().endOf("week").clone().endOf("D")
        );
        setMonthHeader(localDate.format("MMM, YYYY"));
      } else if (tabType === "week5") {
        let localDate = moment()
          .startOf("month")
          .clone()
          .add(getMonth, "M")
          .startOf("M")
          .clone()
          .add(4, "week")
          .startOf("week");
        // let localDate = moment().startOf("month").clone().add(3, "week").startOf("week");
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate
            .clone()
            .endOf("week")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY"),
        };
        let weeksCount = getNumberOfWeeksInMonth(
          localDate.year(),
          localDate.month()
        );
        setWeeksCount(weeksCount);
        if (weeksCount === 5) {
          date_range.end_date = localDate
            .clone()
            .endOf("month")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY");
        }
        setStartDateRange(localDate.clone().startOf("D"));
        setEndDateRange(
          weeksCount === 5
            ? localDate.clone().endOf("month").clone().endOf("D")
            : localDate.clone().endOf("week").clone().endOf("D")
        );
        setMonthHeader(localDate.format("MMMM, YYYY"));
      } else if (tabType === "week6") {
        let localDate = moment()
          .startOf("month")
          .clone()
          .add(getMonth, "M")
          .startOf("M")
          .clone()
          .add(5, "week")
          .startOf("week");
        // let localDate = moment().startOf("month").clone().add(3, "week").startOf("week");
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate
            .clone()
            .endOf("week")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY"),
        };
        let weeksCount = getNumberOfWeeksInMonth(
          localDate.year(),
          localDate.month()
        );
        setWeeksCount(weeksCount);
        console.log("weeksCount: ", weeksCount);
        if (weeksCount === 6) {
          date_range.end_date = localDate
            .clone()
            .endOf("month")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY");
        }
        setStartDateRange(localDate.clone().startOf("D"));
        setEndDateRange(
          weeksCount === 6
            ? localDate.clone().endOf("month").clone().endOf("D")
            : localDate.clone().endOf("week").clone().endOf("D")
        );
        setMonthHeader(localDate.format("MMMM, YYYY"));
      } else if (tabType === "month") {
        //this month tab click
        let localDate = moment().startOf("month");
        date_range = {
          start_date: localDate.clone().add(-1, "d").format("MM/DD/YYYY"),
          end_date: localDate
            .clone()
            .endOf("month")
            .clone()
            .add(1, "d")
            .format("MM/DD/YYYY"),
        };
        let weeksCount = getNumberOfWeeksInMonth(
          localDate.year(),
          localDate.month()
        );
        setWeeksCount(weeksCount);
        setMonthHeader(localDate.format("MMMM, YYYY"));
      } else if (tabType === "prevMonth" || tabType === "nextMonth") {
        // let getMonth = tabType === "prevMonth" ? (_.cloneDeep(currentMonth) - 1) : (_.cloneDeep(currentMonth) + 1);
        // setCurrentMonth(getMonth)
        let localDate = moment()
          .startOf("month")
          .clone()
          .add(getMonth, "M")
          .startOf("M");
        let startDate = localDate.clone().add(-1, "d").format("MM/DD/YYYY");
        let endDate = localDate
          .clone()
          .endOf("month")
          .clone()
          .add(1, "d")
          .format("MM/DD/YYYY");
        setMonthHeader(localDate.format("MMMM, YYYY"));

        date_range = {
          start_date: startDate,
          end_date: endDate,
        };
        let weeksCount = getNumberOfWeeksInMonth(
          localDate.year(),
          localDate.month()
        );
        setWeeksCount(weeksCount);
      }
    }

    // if (isGuest && fromGuestUser) {
    //   return;
    // } else {

    let reqObj = {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      email: isGuest ? "" : authBroker?.payload?.user?.email,
      user_id: isGuest ? atob(uId) : authBroker?.payload?.user?.user_id,
      company_id: isGuest ? "" : authBroker?.payload?.user?.company_id,
      date_range,
      language: activeLanguage ? activeLanguage : "",
      isEvents: isEvents,
      isCoaching: isCoaching,
    };

    reqObj.fromEvent = false;
    reqObj.mySession = false;
    if (mySession) {
      reqObj.fromEvent = true;
      reqObj.mySession = true;
    } else {
      if (window.location.pathname.includes("/learn/group-workshops")) {
        reqObj.fromEvent = true;
        reqObj.mySession = false;
      }
    }

    if (fromPartner && (providerId || selectedPartner)) {
      reqObj.provider_id = providerId
        ? providerId
        : selectedPartner != "all"
        ? selectedPartner
        : "";
      reqObj.isAll = allPartners
        ? selectedPartner != "all"
          ? false
          : true
        : false;
      reqObj.fromEvent = true;
      reqObj.mySession = false;
    }

    // setIsLoading(true);
    setTimeout(() => {
      setIsLoading(true);
    },100);
    if (isLive) {
      let token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
      dispatch(
        getLiveSessionList({
          module: "getLiveSessions",
          postData: {
            token: token ? token : "",
          },
        })
      );
    } else {
      dispatch(
        getCalendarSessionList({
          module: "calendarSessionListEcom",
          postData: reqObj,
        })
      );
    }
  };
  useEffect(() => {
    let calendarSessions = isLive
      ? liveSessionsResponse
      : calenderSessionListArray;
    // console.log('Calendar List Array', calendarSessions)

    if (!_.isEmpty(calendarSessions)) {
      setIsLoading(false);
      setFetchData(true);
      let events = range(0, 6).map(() => []);
      // for (let calendarData of calendarSessions) {
      if (calendarSessions.status === "success") {
        const sessionData = _.clone(calendarSessions.payload.payload);
        // console.log('sessionData Calendar List Array', sessionData)
        if (_.isArray(sessionData) && !_.isEmpty(sessionData)) {
          let api_date_format = "YYYY-MM-DD HH:mm";
          const userTz = moment.tz.guess();

          // const area = timezoneArea(timezoneOffset);
          const area = userDetails.timezoneAbbr || "Europe/London";
          // console.log('AREA', userDetails)
          for (let session of sessionData) {
            const actualTimezoneOffset = session.timezone?.includes(":")
              ? session.timezone?.replace(":", "")
              : "-0400";

            // const actualArea = timezoneArea(actualTimezoneOffset);
            const actualArea = userDetailRes?.payload?.payload?.timezoneAbbr;
            // console.log('event session Calendar List Array', session)
            if (_.isArray(session.date_time)) {
              let startDate = session?.first_start_date_time?.split(" ")[0];
              let startTime = session?.first_start_date_time?.split(" ")[1];
              let endDate = session?.last_end_date_time?.split(" ")[0];
              let endTime = session?.last_end_date_time?.split(" ")[1];
              let sessionStartDate = moment
                .utc(
                  startDate?.replaceAll("-", "/") + " " + startTime,
                  "DD/MM/YYYY HH:mm"
                )
                .tz(actualArea);
              let sessionEndDate = moment
                .utc(endDate?.replaceAll("-", "/") + " " + endTime)
                .tz(actualArea);
              for (let event_time of session.date_time) {
                let startUTC =
                  event_time?.start_date?.replaceAll("-", "/") +
                  " " +
                  event_time.start_time;
                let endUTC =
                  event_time?.end_date?.replaceAll("-", "/") +
                  " " +
                  event_time.end_time;

                console.log("AREA", area);
                let startDateTime = moment.utc(startUTC).tz(area);
                let endDateTime = moment.utc(endUTC).tz(area);

                const currentDateTime = moment().tz(area);
                console.log(
                  "currentDateTime112233",currentDateTime);
                const isShow = _.cloneDeep(currentDateTime).add(48, 'hours').isBefore(startDateTime);
                console.log("startdate",startDateTime,currentDateTime)
                const weekDay = startDateTime?.day();
                const startTense = getTense(
                  getTenseDiff(
                    moment
                      .duration(startDateTime?.diff(currentDateTime))
                      .asDays()
                  )
                );
                const endTense = getTense(
                  getTenseDiff(
                    moment.duration(endDateTime?.diff(currentDateTime)).asDays()
                  )
                );
                const tense =
                  startTense === "past" && endTense === "past"
                    ? "past"
                    : endTense;
                const cross30Timer = moment(sessionStartDate)
                  .clone()
                  .add(30, "minutes");
                const enableAfterTime = startDateTime
                  .clone()
                  .subtract(session.live_session_duration, "seconds");
                console.log(
                  "enableAfterTime",
                  startUTC,
                  enableAfterTime.format("DD-MM-YYYY hh:mm:ss a"),
                  event_time.segment_title
                );

                if (!isNaN(weekDay)) {
                  let data = {
                    startTense: startTense,
                    endTense: endTense,
                    startUTC: startUTC,
                    endUTC: endUTC,
                    segmentStart: moment.utc(startUTC).tz(actualArea),
                    segmentEnd: moment.utc(endUTC).tz(actualArea),
                    sessionMode: event_time.sessionMode,
                    start: moment(
                      startDateTime?.format(api_date_format)
                    ).toDate(),
                    end: moment(endDateTime?.format(api_date_format)).toDate(),
                    durationValue: _.toInteger(
                      moment
                        .duration(endDateTime?.diff(startDateTime))
                        .asMinutes()
                    ),
                    duration:
                      _.toInteger(
                        moment
                          .duration(endDateTime?.diff(startDateTime))
                          .asMinutes()
                      ) + "mins",
                    tense: tense,
                    tenseDayDiff: getTenseDiff(
                      moment
                        .duration(startDateTime?.diff(currentDateTime))
                        .asDays()
                    ),
                    // timezone: moment.tz(userTz).format('z'),
                    timezone: currentDateTime?.format("z"),
                    userTimezone: startDateTime?.format("z"),
                    actualTimezoneAbbr: sessionStartDate?.format("z"), //timezoneTagName(session.timezoneAbbr),
                    sessionStartTimezone: sessionStartDate?.format("z"), //timezoneTagName(session.timezoneAbbr),
                    sessionEndTimezone: sessionEndDate?.format("z"), //timezoneTagName(session.timezoneAbbr),
                    title: session.session_name,
                    kickoff_session: session.kickoff_session,
                    channel: session.channel_name,
                    author: session.instructor,
                    meetingId: event_time.meeting_id,
                    sessionId: session.session_id,
                    eventId: session.event_id,
                    eventCode: session.event_code,
                    eventName: session.event_name,
                    userId: authBroker?.payload?.user.user_id,
                    userRole: userRole,
                    id: events.length,
                    source:
                      session.source === "ecom" || session.source === "xsel"
                        ? "xsel"
                        : "broker",
                    isCertify: session.is_certify ? session.is_certify : false,
                    is_addToCart: session.is_addtocart,
                    is_registered: session.is_registered,
                    is_paid:
                      event_time.is_host || event_time.is_instructor
                        ? true
                        : session.is_paid,
                    is_cancelled: session.is_cancelled,
                    is_expired: event_time.is_expired,
                    is_completed: event_time.is_completed,
                    is_live: event_time.is_live,
                    watch_url: event_time.watch_url,
                    selling_price:
                      event_time.is_host || event_time.is_instructor
                        ? 0
                        : session.product_sale_price,
                    productId: session.product_id,
                    coachId: session?.author,
                    segmentId: event_time.segment_id,
                    session_status: event_time.session_status,
                    segmentTitle: event_time.segment_title,
                    segmentNumber: event_time.segment_number,
                    totalSegment: session.total_segment,
                    is_host: event_time.is_host,
                    is_boardcast:
                      session.delivery_mode != "virtual_interactive" &&
                      session.delivery_mode != "face_to_face" &&
                      session.delivery_mode != "blended_session"
                        ? true
                        : false,
                    is_participant:
                      event_time.is_instructor && !event_time.is_host
                        ? true
                        : event_time.is_participant,
                    hostZoomId: authBroker?.payload?.user.zoom_id,
                    start_url: event_time.start_url ? event_time.start_url : "",
                    join_url:
                      session.delivery_mode === "blended_session"
                        ? event_time.inperson_meeting_url
                          ? event_time.inperson_meeting_url
                          : ""
                        : event_time.join_url
                        ? event_time.join_url
                        : "",
                    current_date_time: currentDateTime,
                    current_time: currentDateTime?.format(api_date_format),
                    sessionStartDate: moment(
                      sessionStartDate?.format(api_date_format)
                    ).toDate(),
                    sessionEndDate: moment(
                      sessionEndDate?.format(api_date_format)
                    ).toDate(),
                    delivery_mode: session.delivery_mode,
                    location: session.location,
                    showRegister:
                      sessionStartDate?.isSameOrAfter(currentDateTime),
                    cross30: currentDateTime?.isSameOrBefore(cross30Timer),
                    enableAfterTime: enableAfterTime,
                    startDateTime: startDateTime,
                    endDateTime: endDateTime,
                    enableReschedule: isShow,
                    enableJoin:
                      currentDateTime?.isSameOrAfter(enableAfterTime) &&
                      currentDateTime?.isSameOrBefore(endDateTime),
                    beforeEndTime: currentDateTime?.isSameOrBefore(endDateTime),
                    marketting_event_banner: session.marketting_event_banner,
                    marketting_event_desc: session.marketting_event_desc,
                    marketting_event_thumbnail:
                      session.marketting_event_thumbnail,
                    is_recurring: session.is_recurring,
                    is_recurring_check: session.is_recurring_check,
                    total_auto_reg_ssn: session?.total_auto_reg_ssn,
                    purchased_info: getProcureInfo(session?.purchased_info),
                    provider: session?.provider,
                    cancel_request: session?.cancel_request,
                    product_type: session?.product_type,
                    hours:session?.hours,
                    language:session?.language,
                  };
                  // if (cross30Timer.isBetween(currentDateTime, currentDateTime.clone().add(1, 'hour'))) {

                  // }
                  console.log('Calendar List Array Individual', data)
                  events[weekDay].push(data);
                }
                // }
              }
            }
          }
        }
      }
      // }
      // console.log('events final data Calendar List Array', events)
      //   setMyEvents(events)
      dispatch(getCalendarSessionListClear());
      dispatch(getLiveSessionListClear());
      if (_.flatten(events).length > 0) {
        const currentWeekEnd = currentWeekStart.clone().endOf("week");
        if (moment().isBetween(currentWeekStart, currentWeekEnd)) {
          const timezoneOffset = !_.isEmpty(userDetails.timezone)
            ? userDetails.timezone.replace(":", "")
            : "-0400";
          const area = timezoneArea(timezoneOffset);
          var today = moment().tz(area);
          var todayDay = today.day();
          dispatch(calendarLiveEventSaved(events[todayDay]));
        }
        let sortedEvents = [];
        for (let event of events) {
          sortedEvents.push(_.sortBy(event, "start"));
        }
        // console.log("sortedEventsMarketting", sortedEvents)
        let sortedEventsNew = [];
        for (let i = 0; i < sortedEvents.length; i++) {
          const element = sortedEvents[i];
          for (let j = 0; j < element.length; j++) {
            const temp = element[j];
            if (
              isInCurrentMonth(
                currentMonth,
                startDateRange,
                endDateRange,
                temp.start
              )
            ) {
              sortedEventsNew.push(temp);
            }
          }
        }
        sortedEventsNew.sort(function (a, b) {
          return new Date(a.start) - new Date(b.start);
        });
        console.log("sortedEventsMarketting", sortedEventsNew);
        setSelectedSession(sortedEventsNew[selectedSessionPos]);
        setSelectedSessionFromHome(sortedEventsNew[selectedSessionPos]);
        setEvents(sortedEventsNew);

        if (isGuest && !_.isEmpty(sIdParam)) {
          for (let i = 0; i < sortedEventsNew.length; i++) {
            const element = sortedEventsNew[i];
            if (element.segmentId === sIdParam) {
              setSelectedSessionPos(i);
              setSelectedSession(sortedEventsNew[i]);
              setSelectedSessionFromHome(sortedEventsNew[i]);
              break;
            }
          }
        }
      } else {
        setEvents([]);
      }
    }
  }, [calenderSessionListArray, liveSessionsResponse]);

  useEffect(() => {
    if (!_.isEmpty(hostSessionInfo)) {
      if (hostSessionInfo.status === "success") {
        if (!_.isEmpty(hostSessionInfo.payload.payload)) {
          console.log("hostSessionInfo", hostSessionInfo.payload.payload);
          const hostData = hostSessionInfo.payload.payload.data;
          if (hostData.start_url && showLoader) {
            window.open(hostData.start_url, "_blank");
            // dispatchAPICall();
            getSessionsAccordingTab(selectedTab);
          } else {
            if (userRole === "realtor" || userRole === "customer") {
              dispatch(
                homePageMsg("Server Error, please contact your manager")
              );
            } else if (userRole === "manager") {
              dispatch(homePageMsg("Server Error, please contact your admin"));
            } else {
              dispatch(homePageMsg("Server Error, please contact support"));
            }
          }
          setShowLoader(false);
        } else {
          // console.log(hostSessionInfo.error.message)
          dispatch(homePageMsg(hostSessionInfo.error.message));
        }
      } else {
        dispatch(homePageMsg(hostSessionInfo.error.message));
      }
      // dispatch(homePageShowMsg(true))
      setShowLoader(false);
      // setTimeout(() => {
      //     dispatch(homePageShowMsg(false))
      // }, 5000)
      // dispatch(hostSessionClear())
    }
  }, [hostSessionInfo]);

  useEffect(() => {
    // console.log('joinSessionData', joinSessionData);
    if (!_.isEmpty(joinSessionData)) {
      if (joinSessionData.status === "success") {
        if (!_.isEmpty(joinSessionData.payload.payload)) {
          const sessionData = joinSessionData.payload.payload;
          setShowLoader(false);
          if (sessionData.join_url) {
            window.open(sessionData.join_url, "_blank");
            // dispatchAPICall();
            getSessionsAccordingTab(selectedTab);
          } else {
            if (userRole === "realtor" || userRole === "customer") {
              dispatch(
                homePageMsg(
                  "Error joining session, please contact your manager"
                )
              );
            } else if (userRole === "manager") {
              dispatch(
                homePageMsg("Error joining session, please contact your admin")
              );
            } else {
              dispatch(
                homePageMsg("Error joining session, please contact support")
              );
            }
          }
        } else {
          dispatch(homePageMsg(joinSessionData.error.message));
        }
      } else {
        // console.log(joinSessionData.error.message)
        dispatch(homePageMsg(joinSessionData.error.message));
      }
      // dispatch(homePageShowMsg(true))
      // setShowLoader(false)
      // setTimeout(() => {
      //     dispatch(homePageShowMsg(false))
      // }, 5000)
      // dispatch(joinSessionClear())
    }
  }, [joinSessionData]);

  useEffect(() => {
    // console.log('sessionCalledData', sessionCancelledData)
    if (!_.isEmpty(sessionCancelledData)) {
      setIsLoading(false);
      if (sessionCancelledData.status === "success") {
        // dispatchAPICall();
        getSessionsAccordingTab(selectedTab);
        let msg = "Halifax team will connect with you shortly.";
        if (selectedSession.source === "broker") {
          msg = "You have successfully unregistered from the session(s).";
        }
        dispatch(homePageMsg(msg));
        clickStreamUser("session-unregistered-successfull", {
          session_id: sessionDataForModal.sessionId,
          user_id: authBroker?.payload?.user?.user_id,
          message: msg,
        });
        // dispatchAPICall();
      } else {
        dispatch(homePageMsg("Unable to unregister. Please try again later."));
      }
      dispatch(homePageShowMsg(true));
      setShowLoader(false);
      setTimeout(() => {
        dispatch(homePageShowMsg(false));
      }, 5000);
      dispatch(cancelSessionDataClear());
    }
  }, [sessionCancelledData]);

  useEffect(() => {
    if (!_.isEmpty(enrollAvailability)) {
      setConfirmModal(false);
      if (enrollAvailability.status === "success") {
        let data = enrollAvailability.payload.payload;
        if (!_.isEmpty(data)) {
          console.log(data);
          const eventData = _.flattenDeep(events);
          for (let events of eventData) {
            console.log(events);
            if (
              events.source === data.origin &&
              events.sessionId === data.session_id
            ) {
              navigate(
                `/shopping/${events.productId}?addToCart=${events.is_addToCart}&source=session`
              );
            }
          }
        }
      } else if (enrollAvailability?.status === "error") {
        dispatch(homePageMsg(enrollAvailability.error.message));
        window.scrollTo(0, 0);
      }
      setShowLoader(false);
      dispatch(homePageShowMsg(true));
      setTimeout(() => {
        dispatch(homePageShowMsg(false));
      }, 5000);
      dispatch(getEnrollAvailabilityClear());
    }
  }, [enrollAvailability]);

  useEffect(() => {
    // console.log("enrolled FROM Home page Calendar", enrollBrokerSession, currentWeekStart);
    if (!_.isEmpty(enrollBrokerSession)) {
      setConfirmModal(false);
      setIsLoading(false);
      if (enrollBrokerSession?.status === "success") {
        let data = enrollBrokerSession.payload.payload;
        dispatch(homePageMsg(enrollBrokerSession.payload.message));
        clickStreamUser("session-registered-successfull", {
          // event_id: event_id,
          session_id: data.session_id,
          user_id: authBroker?.payload?.user?.user_id,
          message: enrollBrokerSession.payload.message,
        });
        // dispatchAPICall();
        getSessionsAccordingTab(selectedTab);
      } else if (enrollBrokerSession?.status === "error") {
        dispatch(homePageMsg(enrollBrokerSession.error.message));
      }
      // dispatch(homePageShowMsg(true))
      // setShowLoader(false)
      // setTimeout(() => {
      //     dispatch(homePageShowMsg(false))
      // }, 5000)
      // dispatch(getEnrollBrokerSessionClear());
    }
  }, [enrollBrokerSession]);

  const setDeliveryMode = (session) => {
    switch (session?.delivery_mode) {
      case "virtual_broadcast":
        return "Virtual Broadcast";
      case "virtual_interactive":
        return "Virtual Interactive";
      case "face_to_face":
        return "In-person";
      case "blended_session":
        return "In-person/Virtual";
      case "Online":
        return "Online";
    }
  };

  const renderButton = (eventDetail) => {
    console.log("Event Detail", eventDetail);

    if (!_.isEmpty(eventDetail)) {
      if (eventDetail.source === "broker") {
        if (eventDetail.is_registered && eventDetail.is_participant) {
          if (eventDetail.delivery_mode === "face_to_face") {
            const startTime = moment(`${eventDetail.start}`).subtract(
              1,
              "hour"
            );
            const endTime = moment(`${eventDetail.end}`);
            const currentTime = moment(eventDetail.current_time);
            if (currentTime.isBefore(startTime)) {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                  <RenderButtonForCalendar
                    isActive={true}
                    title={isEvents ? "Cancel" : t("Decline")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) =>
                      cancelSessionConfirmation(eventDetail)
                    }
                  />
                </>
              );
            } else {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                </>
              );
            }
          } else if (eventDetail.tense === "past") {
            if (eventDetail.watch_url) {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title="Watch"
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => watchSession(eventDetail)}
                  />
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                </>
              );
            } else {
              return (
                <>
                  {/* Session has ended. {eventDetail.watch_url} */}
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                </>
              );
            }
          } else if (eventDetail.tense === "future") {
            console.log("futureTense");
            return (
              <>
                <RenderButtonForCalendar
                  isActive={false}
                  title="Join"
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={() => {
                    console.log("eventDetail", eventDetail);
                  }}
                />
                <RenderButtonForCalendar
                  isActive={true}
                  title={isEvents ? "Cancel" : t("Decline")}
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={(eventDetail) =>
                    cancelSessionConfirmation(eventDetail)
                  }
                />
                <RenderButtonForCalendar
                  isActive={true}
                  title={t("viewMore")}
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={(eventDetail) => redirectToEvent(eventDetail)}
                />
              </>
            );
          } else {
            const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const startTime = moment(`${eventDetail.start}`).subtract(
              1,
              "hour"
            );
            const endTime = moment(`${eventDetail.end}`);
            const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
            // console.log('meetingId', eventDetail.meetingId)
            if (currentTime.isBetween(startTime, endTime)) {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title="Join"
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) =>
                      eventDetail.is_boardcast
                        ? showBoardcast(eventDetail)
                        : launchSession(eventDetail)
                    }
                  />
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                </>
              );
            } else if (currentTime.isAfter(endTime)) {
              if (eventDetail.watch_url) {
                return (
                  <>
                    <RenderButtonForCalendar
                      isActive={true}
                      title="Watch"
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => watchSession(eventDetail)}
                    />
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => redirectToEvent(eventDetail)}
                    />
                  </>
                );
              } else {
                return (
                  <>
                    {/* Session has ended. */}
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => redirectToEvent(eventDetail)}
                    />
                  </>
                );
              }
            } else {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={false}
                    title="Join"
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={() => {}}
                  />
                  <RenderButtonForCalendar
                    isActive={true}
                    title={isEvents ? "Cancel" : t("Decline")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) =>
                      cancelSessionConfirmation(eventDetail)
                    }
                  />
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                </>
              );
            }
          }
        } else if (eventDetail.is_host) {
          if (
            eventDetail.delivery_mode === "face_to_face" ||
            eventDetail.delivery_mode === "blended_session"
          ) {
            return (
              <>
                {userRole === "host" || userRole === "instructor" ? (
                  ""
                ) : (
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                )}
              </>
            );
          } else if (eventDetail.tense === "future") {
            return (
              <>
                <button className={"btn-join opacity-half"}>Host</button>
                {userRole === "realtor" ||
                userRole === "customer" ||
                userRole === "manager" ? (
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                ) : (
                  ""
                )}
              </>
            );
          } else if (eventDetail.tense === "present") {
            const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const startTime = moment(`${eventDetail.start}`)
              .tz(systemTz)
              .subtract(1, "hour");
            const endTime = moment(`${eventDetail.end}`).tz(systemTz);
            const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
            // console.log('meetingId', eventDetail.meetingId)
            if (currentTime.isBetween(startTime, endTime)) {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title="Host"
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) =>
                      eventDetail.is_boardcast
                        ? showBoardcast(eventDetail)
                        : hostSessionData(eventDetail)
                    }
                  />
                  {userRole === "realtor" ||
                  userRole === "customer" ||
                  userRole === "manager" ? (
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => redirectToEvent(eventDetail)}
                    />
                  ) : (
                    ""
                  )}
                </>
              );
            } else if (currentTime.isAfter(endTime)) {
              return (
                <>
                  {userRole === "realtor" ||
                  userRole === "customer" ||
                  userRole === "manager" ? (
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => redirectToEvent(eventDetail)}
                    />
                  ) : (
                    ""
                  )}
                </>
              );
            } else {
              return (
                <>
                  <button className={"btn-join opacity-half"}>Host</button>
                  {userRole === "realtor" ||
                  userRole === "customer" ||
                  userRole === "manager" ? (
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => redirectToEvent(eventDetail)}
                    />
                  ) : (
                    ""
                  )}
                </>
              );
            }
          } else {
            if (
              userRole === "realtor" ||
              userRole === "customer" ||
              userRole === "manager"
            ) {
              return (
                <RenderButtonForCalendar
                  isActive={true}
                  title={t("viewMore")}
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={(eventDetail) => redirectToEvent(eventDetail)}
                />
              );
            }
          }
        } else {
          if (eventDetail.tense === "past") {
            return (
              <>
                <RenderButtonForCalendar
                  isActive={true}
                  title={t("viewMore")}
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={(eventDetail) => redirectToEvent(eventDetail)}
                />
                {/* Session has ended. */}
              </>
            );
          } else {
            if (userRole === "host" || userRole === "instructor") {
              if (
                eventDetail.delivery_mode === "face_to_face" ||
                eventDetail.delivery_mode === "blended_session"
              ) {
                <RenderButtonForCalendar
                  isActive={true}
                  title={t("viewMore")}
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={(eventDetail) => redirectToEvent(eventDetail)}
                />;
              } else {
                <RenderButtonForCalendar
                  isActive={true}
                  title="Join"
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={(eventDetail) =>
                    eventDetail.is_boardcast
                      ? showBoardcast(eventDetail)
                      : launchSession(eventDetail)
                  }
                />;
              }
            } else {
              if (eventDetail.showRegister || eventDetail.beforeEndTime) {
                return (
                  <>
                    {isEvents && (
                      <RenderButtonForCalendar
                        isActive={true}
                        title={isLoggedIn ? "Register" : "Signup to Register"}
                        isLoaded={showLoader}
                        eventData={eventDetail}
                        onClick={(eventDetail) => {
                          if (
                            localStorage.getItem(
                              SessionKeys.API_TOKEN_BROKER
                            ) === null
                          ) {
                            navigate("/login");
                          } else {
                            registerSessionConfirmation(eventDetail);
                          }
                        }}
                      />
                    )}
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => redirectToEvent(eventDetail)}
                    />
                  </>
                );
              } else {
                return (
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => {
                      redirectToEvent(eventDetail);
                    }}
                  />
                );
              }
            }
          }
          // console.log('EVENT CLICKED NOT PAID', eventDetail.title)
        }
      } else {
        if (
          !eventDetail.is_host &&
          !_.isEmpty(eventDetail?.purchased_info) &&
          !eventDetail?.purchased_info?.isFree &&
          eventDetail?.purchased_info?.price > 0
        ) {
          return (
            <>
              {eventDetail.session_status === 1 && (
                <button
                  className={`btn-join active`}
                  onClick={() => {
                    proceedToPurchase(eventDetail, eventDetail.purchased_info);
                  }}
                >
                  {eventDetail.isAddToCart ? "Added in Cart" : "Purchase"}
                </button>
              )}

              <RenderButtonForCalendar
                isActive={true}
                title={t("viewMore")}
                isLoaded={showLoader}
                eventData={eventDetail}
                onClick={(eventDetail) => {
                  redirectToEvent(eventDetail);
                }}
              />
            </>
          );
        } else if (eventDetail.is_registered && eventDetail.is_participant) {
          console.log("eventDetail1", eventDetail);
          if (eventDetail.delivery_mode === "face_to_face") {
            const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const startTime = moment(`${eventDetail.start}`).subtract(
              1,
              "hour"
            );
            const endTime = moment(`${eventDetail.end}`);
            const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
            if (currentTime.isBefore(startTime)) {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title={isEvents ? "Cancel" : t("Decline")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) =>
                      cancelSessionConfirmation(eventDetail)
                    }
                  />
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => {
                      redirectToEvent(eventDetail);
                    }}
                  />
                </>
              );
            } else {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => {
                      redirectToEvent(eventDetail);
                    }}
                  />
                </>
              );
            }
          } else if (eventDetail.tense === "past") {
            if (eventDetail.watch_url) {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title="Watch"
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => watchSession(eventDetail)}
                  />
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => {
                      redirectToEvent(eventDetail);
                    }}
                  />
                </>
              );
            } else {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => {
                      redirectToEvent(eventDetail);
                    }}
                  />
                  {/* Session has ended. {eventDetail.watch_url} */}
                </>
              );
            }
          } else if (eventDetail.tense === "future") {
            return (
              <>
                <RenderButtonForCalendar
                  isActive={false}
                  title="Join"
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={() => {}}
                />

                <RenderButtonForCalendar
                  isActive={true}
                  title={isEvents ? "Cancel" : t("Decline")}
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={(eventDetail) =>
                    cancelSessionConfirmation(eventDetail)
                  }
                />
                <RenderButtonForCalendar
                  isActive={true}
                  title={t("viewMore")}
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={(eventDetail) => {
                    redirectToEvent(eventDetail);
                  }}
                />
              </>
            );
          } else {
            const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const startTime = moment(`${eventDetail.start}`).subtract(
              1,
              "hour"
            );
            const endTime = moment(`${eventDetail.end}`);
            const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
            // console.log('meetingId', eventDetail.meetingId)
            if (currentTime.isBetween(startTime, endTime)) {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title="Join"
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => launchSession(eventDetail)}
                  />
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                </>
              );
            } else if (currentTime.isAfter(endTime)) {
              if (eventDetail.watch_url) {
                return (
                  <>
                    <RenderButtonForCalendar
                      isActive={true}
                      title="Watch"
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => watchSession(eventDetail)}
                    />
                  </>
                );
              } else {
                return (
                  <>
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => {
                        redirectToEvent(eventDetail);
                      }}
                    />
                    {/* Session has ended. */}
                  </>
                );
              }
            } else {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={false}
                    title="Join"
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={() => {}}
                  />
                  <RenderButtonForCalendar
                    isActive={true}
                    title={isEvents ? "Cancel" : t("Decline")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) =>
                      cancelSessionConfirmation(eventDetail)
                    }
                  />
                </>
              );
            }
          }
        } else if (eventDetail.is_host) {
          if (
            eventDetail.delivery_mode === "face_to_face" ||
            eventDetail.delivery_mode === "blended_session"
          ) {
            return (
              <>
                {userRole === "host" || userRole === "instructor" ? (
                  ""
                ) : (
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                )}
              </>
            );
          } else if (eventDetail.tense === "future") {
            return (
              <>
                <button className={"btn-join opacity-half"}>Host</button>
                {userRole === "realtor" ||
                userRole === "customer" ||
                userRole === "manager" ? (
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                ) : (
                  ""
                )}
              </>
            );
          } else if (eventDetail.tense === "present") {
            const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const startTime = moment(`${eventDetail.start}`)
              .tz(systemTz)
              .subtract(1, "hour");
            const endTime = moment(`${eventDetail.end}`).tz(systemTz);
            const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
            // console.log('meetingId', eventDetail.meetingId)
            if (currentTime.isBetween(startTime, endTime)) {
              return (
                <>
                  <RenderButtonForCalendar
                    isActive={true}
                    title="Host"
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) =>
                      eventDetail.is_boardcast
                        ? showBoardcast(eventDetail)
                        : hostSessionData(eventDetail)
                    }
                  />
                  {userRole === "realtor" ||
                  userRole === "customer" ||
                  userRole === "manager" ? (
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => redirectToEvent(eventDetail)}
                    />
                  ) : (
                    ""
                  )}
                </>
              );
            } else if (currentTime.isAfter(endTime)) {
              return (
                <>
                  {userRole === "realtor" ||
                  userRole === "customer" ||
                  userRole === "manager" ? (
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => redirectToEvent(eventDetail)}
                    />
                  ) : (
                    ""
                  )}
                </>
              );
            } else {
              return (
                <>
                  <button className={"btn-join opacity-half"}>Host</button>
                  {userRole === "realtor" ||
                  userRole === "customer" ||
                  userRole === "manager" ? (
                    <RenderButtonForCalendar
                      isActive={true}
                      title={t("viewMore")}
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => redirectToEvent(eventDetail)}
                    />
                  ) : (
                    ""
                  )}
                </>
              );
            }
          } else {
            return (
              <>
                {userRole === "realtor" ||
                userRole === "customer" ||
                userRole === "manager" ? (
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("viewMore")}
                    isLoaded={showLoader}
                    eventData={eventDetail}
                    onClick={(eventDetail) => redirectToEvent(eventDetail)}
                  />
                ) : (
                  ""
                )}
              </>
            );
          }
        } else {
          if (eventDetail.tense === "past") {
            return (
              <>
                <RenderButtonForCalendar
                  isActive={true}
                  title={t("viewMore")}
                  isLoaded={showLoader}
                  eventData={eventDetail}
                  onClick={(eventDetail) => {
                    redirectToEvent(eventDetail);
                  }}
                />
                {/* Session has ended. */}
              </>
            );
          } else {
            if (eventDetail?.purchased_info?.price === 0) {
              if (userRole === "host" || userRole === "instructor") {
                const systemTz =
                  Intl.DateTimeFormat().resolvedOptions().timeZone;
                const startTime = moment(`${eventDetail.start}`)
                  .tz(systemTz)
                  .subtract(1, "hour");
                const endTime = moment(`${eventDetail.end}`).tz(systemTz);
                const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
                if (currentTime.isBetween(startTime, endTime)) {
                  return (
                    <RenderButtonForCalendar
                      isActive={true}
                      title="Join"
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) =>
                        eventDetail.is_boardcast
                          ? showBoardcast(eventDetail)
                          : launchSession(eventDetail)
                      }
                    />
                  );
                } else {
                  return (
                    <RenderButtonForCalendar
                      isActive={false}
                      title="Join"
                      isLoaded={showLoader}
                      eventData={eventDetail}
                      onClick={(eventDetail) => {}}
                    />
                  );
                }
              } else {
                if (eventDetail.showRegister || eventDetail.beforeEndTime) {
                  return (
                    <>
                      {isEvents && (
                        <RenderButtonForCalendar
                          isActive={true}
                          title={isLoggedIn ? "Register" : "Signup to Register"}
                          isLoaded={showLoader}
                          eventData={eventDetail}
                          onClick={(eventDetail) => {
                            if (
                              localStorage.getItem(
                                SessionKeys.API_TOKEN_BROKER
                              ) === null
                            ) {
                              navigate("/login");
                            } else {
                              registerSessionConfirmation(eventDetail);
                            }
                          }}
                        />
                      )}
                      <RenderButtonForCalendar
                        isActive={true}
                        title={t("viewMore")}
                        isLoaded={showLoader}
                        eventData={eventDetail}
                        onClick={(eventDetail) => {
                          redirectToEvent(eventDetail);
                        }}
                      />
                    </>
                  );
                } else {
                  return (
                    <>
                      <RenderButtonForCalendar
                        isActive={true}
                        title={t("viewMore")}
                        isLoaded={showLoader}
                        eventData={eventDetail}
                        onClick={(eventDetail) => {
                          redirectToEvent(eventDetail);
                        }}
                      />
                    </>
                  );
                }
              }
            }
          }
          // console.log('EVENT CLICKED NOT PAID', eventDetail.title)
        }
      }
    }
  };

  const renderJoinUs = (eventDetail) => {
    console.log("Event Detail", eventDetail);
    // localStorage.setItem("SELECTED_SESSION_ID", eventDetail?.sessionId)
    localStorage.setItem("SELECTED_SESSION_NAME", eventDetail?.title);
    localStorage.setItem("SELECTED_EVENT_NAME", eventDetail?.eventName);
    return (
      <>
        <div className="register-box">
          <p className="registenow-head">Register Now!</p>
          <div className="button-share-box">
            <button
              className="btn-join active"
              onClick={() => {
                navigate(`/login`);
              }}
            >
              Our Agent
            </button>
            <button
              className="btn-join active"
              onClick={() => {
                navigate(
                  `/contact?id=${params.get("id")}&uid=${params.get(
                    "uid"
                  )}&guest=${isGuest}`
                );
              }}
              title=" Be our Guest"
            >
              Be our Guest
            </button>
          </div>
        </div>
      </>
    );
  };

  const renderCoachingButtons = (eventDetail) => {
    console.log("Event Detail", eventDetail);
    // localStorage.setItem("SELECTED_SESSION_ID", eventDetail?.sessionId)
    localStorage.setItem("SELECTED_SESSION_NAME", eventDetail?.title);
    localStorage.setItem("SELECTED_EVENT_NAME", eventDetail?.eventName);
    // const enableAfterTime = eventDetail.enableAfterTime
    // const currentDateTime = eventDetail.currentDateTime
    // const endDateTime = eventDetail.endDateTime
    // const enableJoin = currentDateTime.isSameOrAfter(enableAfterTime) && currentDateTime.isSameOrBefore(endDateTime)
    return (
      <>
        <div className="register-box-">
          {/* <p className="registenow-head">Register Now!</p> */}
          <div className="button-share-box d-flex align-items-center justify-content-center gap-2 flex-wrap">
            {(!userDetailRes?.payload?.payload?.roles?.includes("provider")) && eventDetail?.enableReschedule ? (
              <button
                className="btn-primary active-page"
                onClick={() => {
                  handleReschedule(eventDetail.productId, eventDetail?.coachId,eventDetail.sessionId,eventDetail.hours);
                }}
                title={t("Reschedule")}
              >
                {t("Reschedule")}
              </button>
            ) : (
              ""
            )}
            <button
              className="btn-primary"
              onClick={() => {
                let paramsReq = {
                  id: eventDetail.productId,
                };
                let jsonString = JSON.stringify(paramsReq);
                let encodedUrl = btoa(jsonString);
                navigate(`/session-notes?c=${encodedUrl}`);
              }}
              title={t("Session Notes")}
            >
              {t("Session Notes")}{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M4.39467 7.36672H11.9932C12.0745 7.36517 12.1519 7.33179 12.2089 7.27376C12.2658 7.21574 12.2977 7.13769 12.2977 7.0564C12.2977 6.9751 12.2658 6.89706 12.2089 6.83903C12.1519 6.78101 12.0745 6.74764 11.9932 6.74609H4.39467C4.31339 6.74764 4.23597 6.78101 4.17904 6.83904C4.1221 6.89707 4.09021 6.97511 4.09021 7.05641C4.09021 7.1377 4.1221 7.21574 4.17904 7.27377C4.23597 7.3318 4.31339 7.36517 4.39467 7.36672Z"
                  fill="#415385"
                  stroke="#415385"
                  stroke-width="0.3"
                />
                <path
                  d="M4.39467 9.73096H9.07199C9.15323 9.72935 9.23059 9.69595 9.28747 9.63793C9.34434 9.57991 9.3762 9.50189 9.3762 9.42065C9.3762 9.3394 9.34433 9.26139 9.28745 9.20337C9.23057 9.14536 9.15321 9.11196 9.07197 9.11035H4.39467C4.31344 9.11196 4.23607 9.14536 4.17919 9.20338C4.12231 9.2614 4.09045 9.33941 4.09045 9.42066C4.09045 9.50191 4.12231 9.57991 4.17919 9.63793C4.23607 9.69595 4.31344 9.72935 4.39467 9.73096Z"
                  fill="#415385"
                  stroke="#415385"
                  stroke-width="0.3"
                />
                <path
                  d="M9.1735 11.4741H4.39466C4.31236 11.4741 4.23343 11.5068 4.17524 11.565C4.11704 11.6232 4.08435 11.7021 4.08435 11.7844C4.08435 11.8667 4.11704 11.9457 4.17524 12.0039C4.23343 12.0621 4.31236 12.0947 4.39466 12.0947H9.1735C9.25481 12.0932 9.33228 12.0599 9.38924 12.0019C9.44621 11.9438 9.47813 11.8658 9.47813 11.7844C9.47813 11.7031 9.44621 11.625 9.38924 11.567C9.33228 11.509 9.25481 11.4756 9.1735 11.4741Z"
                  fill="#415385"
                  stroke="#415385"
                  stroke-width="0.3"
                />
                <path
                  d="M8.46403 13.8379H4.39458C4.31327 13.8394 4.23581 13.8728 4.17884 13.9308C4.12188 13.9888 4.08996 14.0669 4.08997 14.1482C4.08997 14.2295 4.12189 14.3076 4.17886 14.3656C4.23582 14.4237 4.31329 14.457 4.3946 14.4585H8.46403C8.54533 14.457 8.6228 14.4237 8.67977 14.3656C8.73673 14.3076 8.76865 14.2295 8.76865 14.1482C8.76865 14.0669 8.73673 13.9888 8.67977 13.9308C8.6228 13.8727 8.54533 13.8394 8.46403 13.8379Z"
                  fill="#415385"
                  stroke="#415385"
                  stroke-width="0.3"
                />
                <path
                  d="M18.7972 3.1943C18.7764 3.07674 18.7324 2.96449 18.6678 2.86404C18.6033 2.7636 18.5194 2.67696 18.4212 2.60914L17.5236 1.98656C17.3254 1.84965 17.0811 1.79686 16.844 1.83974C16.607 1.88263 16.3967 2.01769 16.259 2.21535L15.0696 3.9299C15.0539 3.60881 14.9156 3.306 14.6831 3.08399C14.4506 2.86198 14.1417 2.73772 13.8202 2.73687H2.56766C2.2347 2.73726 1.91549 2.86971 1.68006 3.10517C1.44464 3.34062 1.31223 3.65985 1.31189 3.99281V17.212C1.31223 17.545 1.44464 17.8642 1.68006 18.0997C1.91549 18.3351 2.2347 18.4676 2.56766 18.468H13.8202C14.1532 18.4676 14.4724 18.3351 14.7078 18.0997C14.9432 17.8642 15.0756 17.545 15.076 17.212V9.02487C15.905 7.8293 17.8399 5.04112 18.6494 3.87384C18.7177 3.77598 18.766 3.66553 18.7913 3.54888C18.8167 3.43224 18.8187 3.31172 18.7972 3.1943ZM14.4553 17.212C14.4552 17.3805 14.3882 17.5419 14.2692 17.661C14.1501 17.7801 13.9886 17.8471 13.8202 17.8473H2.56766C2.39924 17.8471 2.23778 17.7801 2.1187 17.661C1.99962 17.5419 1.93266 17.3805 1.93251 17.212V3.99279C1.93266 3.82437 1.99962 3.66289 2.1187 3.54379C2.23778 3.42468 2.39924 3.35768 2.56766 3.35748H13.8202C13.9886 3.35768 14.1501 3.42468 14.2692 3.54379C14.3882 3.66289 14.4552 3.82437 14.4554 3.99279V4.81538L10.7032 10.2242C10.6879 10.2578 10.6723 10.2893 10.6577 10.3232L9.85229 13.4275C9.8376 13.4882 9.84144 13.5519 9.86334 13.6104C9.88523 13.6688 9.92416 13.7194 9.97509 13.7556C10.026 13.7917 10.0866 13.8117 10.1491 13.8131C10.2115 13.8144 10.2729 13.797 10.3253 13.7631L13.0065 11.9668C13.0397 11.939 13.0704 11.9084 13.0985 11.8755L14.4554 9.9195L14.4553 17.212ZM11.1466 10.9097L12.2878 11.7014L10.6581 12.7932L11.1466 10.9097ZM12.7605 11.2739L11.3899 10.323L15.2782 4.71775L16.649 5.66872L12.7605 11.2739ZM18.1396 3.51991L17.0029 5.15864L15.6321 4.20768L16.7687 2.56914C16.8124 2.50647 16.8791 2.46365 16.9542 2.45005C17.0293 2.43645 17.1068 2.45317 17.1696 2.49656L18.0672 3.119C18.1297 3.16276 18.1724 3.22945 18.186 3.30454C18.1996 3.37963 18.1829 3.45704 18.1396 3.51991Z"
                  fill="#415385"
                  stroke="#415385"
                  stroke-width="0.3"
                />
              </svg>
            </button>

            {eventDetail.enableJoin || true ? ( // join button will be enabled for all time
              <button
                className="btn-primary active-page"
                onClick={() => {
                  window.open(eventDetail.join_url, "_blank");
                }}
                title={t("clickToJoin")}
              >
                {t("clickToJoin")}
              </button>
            ) : (
              <button disabled className="btn-primary " onClick={() => {}}>
                {t("clickToJoin")}
              </button>
            )}
          </div>
        </div>
      </>
    );
  };

  const renderViewMore = (eventDetail) => {
    return (
      <button
        class="btn-primary reviewbtn guidebtn rpsubmitbtn d-flex gap-1 align-items-center active-page"
        onClick={() => redirectToEvent(eventDetail)}
        title= {t("viewMore")}
      >
        {t("viewMore")}
      </button>
    );
  };

  const proceedToRegister = (session) => {
    // console.log("session", session);
    setConfirmModal(false);
    setIsLoading(true);
    clickStreamUser("register-button-clicked", {
      event_id: session.eventId,
      session_id: session.sessionId,
      session_name: session.title,
      user_id: authBroker?.payload.user.user_id,
      type: session.source,
    });
    dispatch(
      getEnrollBrokerSession({
        module: "enrollBrokerSession",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: session.sessionId,
          event_id: session.eventId,
          type: session.source,
          language: activeLanguage ? activeLanguage : "",
        },
      })
    );
  };

  const proceedToBook = (session) => {
    clickStreamUser("proceed-to-book-session", {
      event_id: session.eventId,
      session_id: session.sessionId,
      session_name: session.title,
      user_id: authBroker?.payload.user.user_id,
    });
    if (session.delivery_mode === "virtual_broadcast") {
      navigate(
        `/shopping/${session.productId}?addToCart=${session.is_addToCart}&source=session`
      );
    } else {
      dispatch(
        getEnrollAvailability({
          module: "checkEnrollAvailability",
          postData: {
            token: session.isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            session_id: session.sessionId,
            event_id: session.eventId,
            type: session.source === "broker" ? "broker" : "xsel",
          },
        })
      );
    }
  };

  const redirectToEvent = (eventDetail) => {
    console.log("redirect to event", eventDetail.isCertify);
    if (
      eventDetail.userRole === "realtor" ||
      userRole === "customer" ||
      eventDetail.userRole === "manager" ||
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) === null
    ) {
      if (eventDetail.source === "broker") {
        let paramsReq = {
          event_id: eventDetail.eventId,
          event_code: "",
          source: "broker",
          provider_id: providerId ? providerId : "",
          provider_name: eventDetail?.provider?.provider_name
            ? eventDetail?.provider?.provider_name
            : "",
          fromCert:
            eventDetail.product_type === "certificate" ? "true" : "false",
          sessionId: eventDetail?.sessionId,
        };
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        navigate(
          !isEvents
            ? `/group-workshop-detail?c=${encodedUrl}`
            : `/event-detail?c=${encodedUrl}`
        );
      } else {
        let paramsReq = {
          event_id: eventDetail.eventId,
          event_code: eventDetail.eventCode,
          source: "ecom",
          provider_id: providerId ? providerId : "",
          provider_name: eventDetail?.provider?.provider_name
            ? eventDetail?.provider?.provider_name
            : "",
          fromCert:
            eventDetail.product_type === "certificate" ? "true" : "false",
          sessionId: eventDetail?.sessionId,
        };
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        navigate(
          !isEvents
            ? `/group-workshop-detail?c=${encodedUrl}`
            : `/event-detail?c=${encodedUrl}`
        );
      }
    }
  };

  const launchSession = (session) => {
    clickStreamUser("launch-session", {
      event_id: session.eventId,
      session_id: session.sessionId,
      session_name: session.session_name,
      user_id: authBroker?.payload.user.user_id,
    });
    if (session.is_boardcast) {
      showBoardcast(session);
    } else {
      if (session.join_url) {
        window.open(session.join_url, "_blank");
        setShowLoader(false);
      } else {
        dispatch(
          joinSession({
            module: "joinZoomMeeting",
            postData: {
              user_id: authBroker?.payload.user.user_id,
              meeting_id: session.meetingId,
              session_id: session.sessionId,
              segment_id: session.segmentId,
            },
          })
        );
      }
      // if (session.meetingId) {
      // } else {
      //     if (session.join_url) {
      //         window.open(session.join_url, '_blank');
      //         dispatchAPICall();
      //     } else {
      //         dispatch(homePageMsg('Host has not yet started the meeting.'))
      //         dispatch(homePageShowMsg(true))
      //         setShowLoader(false)
      //         setTimeout(() => {
      //             dispatch(homePageShowMsg(false))
      //         }, 5000)
      //     }
      // }
    }
  };

  const cancelSessionConfirmation = (session) => {
    setClickedItem(2);
    setIsConfirm(true);
    setShowModalMsg("Would you like to unregister from the session?");
    setConfirmModal(true);
    setSessionDataForModal(session);
    setShowLoader(true);
  };

  const registerSessionConfirmation = (session) => {
    if (session?.is_recurring && session?.is_recurring_check) {
      setClickedItem(1);
      setIsConfirm(true);
      setShowModalMsg(
        `Registering this will enable you to auto-register for all upcoming ${session?.total_auto_reg_ssn} recurring sessions.`
      );
      setConfirmModal(true);
      setSessionDataForModal(session);
      setShowLoader(true);
    } else {
      proceedToRegister(session);
    }
  };

  const cancelSession = (session) => {
    // console.log(session)
    setConfirmModal(false);
    setIsLoading(true);
    clickStreamUser("cancel-session", {
      event_id: session.eventId,
      session_id: session.sessionId,
      session_name: session.title,
      user_id: authBroker?.payload.user.user_id,
    });
    dispatch(
      cancelSessionData({
        module: "sessionCancel",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: session.sessionId,
          session_title: session.title,
          event_id: session.eventId,
          origin: session.source === "broker" ? "broker" : "xsel",
          cancel_type:
            session.cancel_type === undefined ? "" : session.cancel_type,
        },
      })
    );
  };

  const watchSession = (session) => {
    // dispatch(homePageShowMsg(true))
    // dispatch(homePageMsg('You are registered for the Session.'))
    dispatch(
      sessionWatchURLDataResponse({
        id: session.sessionId,
        title: session.title,
        watch_url: session.watch_url,
      })
    );
    navigate("/session/watch");
  };

  const hostSessionData = (session) => {
    if (session.start_url) {
      window.open(session.start_url, "_blank");
      setShowLoader(false);
    } else {
      dispatch(
        hostSession({
          module: "createZoomMeeting",
          postData: {
            user_id: session.userId,
            host_zoom_id: session.hostZoomId,
            meeting_topic: session.title,
            meeting_agaenda: session.title,
            meeting_startdate: moment
              .utc(session.startUTC)
              .format("YYYY-MM-DD HH:mm"),
            duration: _.toNumber(session.durationValue),
            session_id: session.sessionId,
            segment_id: session.segmentId,
          },
        })
      );
    }
  };

  const showBoardcast = (session) => {
    // console.log('boardcast', session)
    dispatch(boardcastDataResponse(session));
    navigate("/session/broadcast/watch");
  };

  const proceedToPurchase = (sessionData, priceInfo1) => {
    clickStreamUser("purchase-button-clicked", {
      event_id: sessionData.eventId,
      session_id: sessionData.sessionId,
      session_name: sessionData.title,
      type: "xsel",
    });
    let tags = [];
    let logoURL = "";
    if (!_.isEmpty(sessionData.provider)) {
      tags.push(sessionData.provider.provider_display_name);
      logoURL = sessionData.provider.provider_img;
    }
    tags.push("Session");
    let deliveryMode =
      sessionData.delivery_mode && sessionData.delivery_mode == "face_to_face"
        ? "In-Person"
        : sessionData.delivery_mode === "blended_session"
        ? "In-Person/Virtual"
        : sessionData.delivery_mode &&
          (sessionData.delivery_mode == "virtual_interactive" ||
            sessionData.delivery_mode == "virtual_broadcast")
        ? "Virtual"
        : "Live";
    tags.push(deliveryMode);
    if (sessionData.author) {
      tags.push(sessionData.author);
    }

    let priceInfo = _.cloneDeep(priceInfo1);
    priceInfo.isAddToCart = sessionData.is_addToCart;

    setIsOpen(true);
    setHeaderProdData({
      id: sessionData.productId,
      title: sessionData.title,
      logoURL: logoURL,
      logoAltText: "ED",
      bannerURL: sessionData.marketting_event_thumbnail,
      tagsArray: tags,
      description: sessionData.marketting_event_desc,
      duration: "",
      view: "",
      price: priceInfo.price,
      isPaid: !priceInfo.isFree,
      priceInfo: priceInfo,
      cancel_request: sessionData.cancel_request,
    });
  };

  const callFunc = () => {
    // setSubmitMessage(
    //   "Your session reschedule request has been submitted successfuly."
    // );
    setShow4HourRescheduleModal(false);
    setCongratsModal(true);
    
  };

  return (
    <>
      {isHome && clickedShareBtn === 0 ? "" : <Loader start={isLoading} />}
      <section className={isHome ? "" : "cal-event-sec"}>
        <div className="container">
          <div id="idDetailScreen" className={isLearn ? "row mt-4" : "row"}>
            {allPartners ? (
              <EventSliderFilterSection
                selectedPartner={selectedPartner}
                setSelectedPartner={setSelectedPartner}
              />
            ) : (
              ""
            )}
            {isLive && (
              <div className="col-md-12 col-xl-12 mb-1">
                <div className="heading-events">{"Live Sessions"}</div>
              </div>
            )}
            {isCoaching && (
              <div className="row">
                <div className="col-md-12">
                  {/* <button className="mb-3 bck-btn" onClick={() => navigate(-1)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="17"
                      viewBox="0 0 10 17"
                      fill="none"
                    >
                      <path
                        d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                        fill="black"
                      />
                    </svg>{" "}
                    {t("back")}
                  </button> */}
                </div>
              </div>
            )}
            {!isLive && !isHome && authBroker?.payload?.user?.access_type !== 3 && (
              <div className="col-md-12 col-xl-12 mb-4">
                <EventCalendarTabsComponent
                  getSessionsAccordingTab={getSessionsAccordingTab}
                  monthHeader={monthHeader}
                  weeksCount={weeksCount}
                  setCurrentMonth={setCurrentMonth}
                  currentMonth={currentMonth}
                  setSelectedSessionPos={setSelectedSessionPos}
                  googleSync={googleSync}
                  isSyncLoading={isSyncLoading}
                  isHome={isHome}
                  syncSessionFunc={syncSessionFunc}
                  setFromGuestUser={setFromGuestUser}
                  isLearn={isLearn}
                  isMobile={isMobile}
                  isEvents={isEvents}
                  isCoaching={isCoaching}
                />
              </div>
            )}

            <div className="col-md-12 col-xl-6">
              <div className="lef-cal-event-tab">
                <div className="tab-box-events">
                  <div
                    className={isHome ? "" : "evnts-info-box"}
                    ref={currentRef}
                  >
                    {false && (
                      <div className="evnt-info-share">
                        {isLearn ||
                        isLive ||
                        isGuest ||
                        userRole === "customer" ||
                        authBroker.payload?.user?.config?.learning_points ===
                          "false" ||
                        !isLoggedIn
                          ? ""
                          : events?.length !== 0 && (
                              <span>Let your peers know what you're up to</span>
                            )}

                        {isLearn ||
                        isLive ||
                        isGuest ||
                        userRole === "customer" ||
                        authBroker.payload?.user?.config?.learning_points ===
                          "false" ||
                        !isLoggedIn ? (
                          ""
                        ) : (
                          <div className="d-flex gap-1">
                            {events?.length !== 0 && (
                              <div className="main_box">
                                {false && (
                                  <label
                                    for="share_button"
                                    onClick={() => {
                                      // setShareClicked(!shareClicked);
                                    }}
                                  >
                                    <span className="sharebtn">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                      >
                                        <path
                                          d="M10.9335 14.1857L7.43441 12.2771C6.82613 12.9272 5.96051 13.3334 5 13.3334C3.15905 13.3334 1.66667 11.841 1.66667 10.0001C1.66667 8.15913 3.15905 6.66675 5 6.66675C5.96046 6.66675 6.82604 7.07296 7.43432 7.72296L10.9335 5.81436C10.8681 5.55376 10.8333 5.28097 10.8333 5.00008C10.8333 3.15913 12.3258 1.66675 14.1667 1.66675C16.0076 1.66675 17.5 3.15913 17.5 5.00008C17.5 6.84103 16.0076 8.33342 14.1667 8.33342C13.2062 8.33342 12.3406 7.92717 11.7323 7.27713L8.23314 9.18575C8.29858 9.44633 8.33333 9.71916 8.33333 10.0001C8.33333 10.281 8.29859 10.5537 8.23318 10.8143L11.7323 12.723C12.3406 12.073 13.2062 11.6667 14.1667 11.6667C16.0076 11.6667 17.5 13.1592 17.5 15.0001C17.5 16.841 16.0076 18.3334 14.1667 18.3334C12.3258 18.3334 10.8333 16.841 10.8333 15.0001C10.8333 14.7192 10.8681 14.4463 10.9335 14.1857ZM5 11.6667C5.92048 11.6667 6.66667 10.9206 6.66667 10.0001C6.66667 9.07958 5.92048 8.33342 5 8.33342C4.07953 8.33342 3.33333 9.07958 3.33333 10.0001C3.33333 10.9206 4.07953 11.6667 5 11.6667ZM14.1667 6.66675C15.0872 6.66675 15.8333 5.92056 15.8333 5.00008C15.8333 4.07961 15.0872 3.33341 14.1667 3.33341C13.2462 3.33341 12.5 4.07961 12.5 5.00008C12.5 5.92056 13.2462 6.66675 14.1667 6.66675ZM14.1667 16.6667C15.0872 16.6667 15.8333 15.9206 15.8333 15.0001C15.8333 14.0796 15.0872 13.3334 14.1667 13.3334C13.2462 13.3334 12.5 14.0796 12.5 15.0001C12.5 15.9206 13.2462 16.6667 14.1667 16.6667Z"
                                          fill="#2D2D2D"
                                        ></path>
                                      </svg>
                                    </span>
                                  </label>
                                )}

                                {shareClicked && (
                                  <div className="sm_list">
                                    <a href="#" className="linkedin">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        onClick={() => {
                                          setClickedShareBtn(1);
                                          // window.open(pdfUrl, "_blank")
                                        }}
                                      >
                                        <defs>
                                          <linearGradient
                                            id="linear-gradientnotes"
                                            x2="1"
                                            y1="0.5"
                                            y2="0.5"
                                            gradientUnits="objectBoundingBox"
                                          >
                                            <stop
                                              offset="0"
                                              stopColor="#415385"
                                            ></stop>
                                            <stop
                                              offset="1"
                                              stopColor="#415385"
                                            ></stop>
                                          </linearGradient>
                                        </defs>
                                        <circle
                                          cx="15"
                                          cy="15"
                                          r="15"
                                          fill="url(#linear-gradientnotes)"
                                          data-name="Ellipse 180"
                                        ></circle>
                                        <circle
                                          cx="13"
                                          cy="13"
                                          r="13"
                                          fill="#fff"
                                          data-name="Ellipse 181"
                                          transform="translate(2 2)"
                                        ></circle>
                                        <path
                                          fill="#415385"
                                          d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                                          data-name="Icon awesome-file-pdf"
                                          transform="translate(9 7)"
                                        ></path>
                                      </svg>
                                    </a>
                                    <a href="#" className="linkedin">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        onClick={() => {
                                          setClickedShareBtn(2);
                                          // window.open(imageUrl, "_blank")
                                        }}
                                      >
                                        <defs>
                                          <linearGradient
                                            id="linear-gradient"
                                            y1="0.5"
                                            x2="1"
                                            y2="0.5"
                                            gradientUnits="objectBoundingBox"
                                          >
                                            <stop
                                              offset="0"
                                              stopColor="#415385"
                                            ></stop>
                                            <stop
                                              offset="1"
                                              stopColor="#415385"
                                            ></stop>
                                          </linearGradient>
                                        </defs>
                                        <circle
                                          id="Ellipse_57"
                                          data-name="Ellipse 57"
                                          cx="15"
                                          cy="15"
                                          r="15"
                                          fill="url(#linear-gradient)"
                                        ></circle>
                                        <circle
                                          id="Ellipse_179"
                                          data-name="Ellipse 179"
                                          cx="13"
                                          cy="13"
                                          r="13"
                                          transform="translate(2 2)"
                                          fill="#fff"
                                        ></circle>
                                        <g
                                          id="surface1"
                                          className="imageuploadsv"
                                          transform="translate(5 4.586)"
                                        >
                                          <path
                                            fill="#415385"
                                            stroke="#415385"
                                            d="M 3.332031 3.332031 C 2.421875 3.332031 1.667969 4.089844 1.667969 5 L 1.667969 15 C 1.667969 15.910156 2.421875 16.667969 3.332031 16.667969 L 16.667969 16.667969 C 17.578125 16.667969 18.332031 15.910156 18.332031 15 L 18.332031 5 C 18.332031 4.089844 17.578125 3.332031 16.667969 3.332031 Z M 3.332031 5 L 16.667969 5 L 16.667969 15 L 3.332031 15 Z M 12.082031 9.167969 L 9.167969 12.5 L 7.082031 10.417969 L 4.816406 13.332031 L 15.207031 13.332031 Z M 12.082031 9.167969 "
                                          />
                                        </g>
                                      </svg>
                                    </a>
                                    <a href="#" className="facebook">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        id="facebook"
                                        data-name="facebook"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        onClick={() => {
                                          setClickedShareBtn(3);
                                          //  window.open(fbTagetUrl, "_blank")
                                        }}
                                      >
                                        <defs>
                                          <linearGradient
                                            id="linear-gradients"
                                            y1="0.5"
                                            x2="1"
                                            y2="0.5"
                                            gradientUnits="objectBoundingBox"
                                          >
                                            <stop
                                              offset="0"
                                              stop-color="#415385"
                                            />
                                            <stop
                                              offset="1"
                                              stop-color="#415385"
                                            />
                                          </linearGradient>
                                        </defs>
                                        <circle
                                          id="Ellipse_198"
                                          data-name="Ellipse 198"
                                          cx="15"
                                          cy="15"
                                          r="15"
                                          fill="url(#linear-gradients)"
                                        />
                                        <circle
                                          id="Ellipse_199"
                                          data-name="Ellipse 199"
                                          cx="13"
                                          cy="13"
                                          r="13"
                                          transform="translate(2 2)"
                                          fill="#fff"
                                          className="fillwhite"
                                        />
                                        <path
                                          id="Icon_awesome-facebook-f"
                                          data-name="Icon awesome-facebook-f"
                                          d="M8.9,8.2l.4-2.638H6.778V3.849A1.319,1.319,0,0,1,8.265,2.424H9.415V.178A14.031,14.031,0,0,0,7.373,0,3.22,3.22,0,0,0,3.926,3.55V5.56H1.609V8.2H3.926v6.376H6.778V8.2Z"
                                          transform="translate(9.487 7.713)"
                                          fill="#415385"
                                        />
                                      </svg>
                                    </a>
                                    <a href="#" className="linkedin">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        id="linkedin"
                                        data-name="linkedin"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        onClick={() => {
                                          setClickedShareBtn(4);
                                          // window.open(linkedinTargetUrl, "_blank")
                                        }}
                                      >
                                        <defs>
                                          <linearGradient
                                            id="linear-gradients"
                                            y1="0.5"
                                            x2="1"
                                            y2="0.5"
                                            gradientUnits="objectBoundingBox"
                                          >
                                            <stop
                                              offset="0"
                                              stop-color="#415385"
                                            />
                                            <stop
                                              offset="1"
                                              stop-color="#415385"
                                            />
                                          </linearGradient>
                                        </defs>
                                        <circle
                                          id="Ellipse_57"
                                          data-name="Ellipse 57"
                                          cx="15"
                                          cy="15"
                                          r="15"
                                          fill="url(#linear-gradients)"
                                        />
                                        <circle
                                          id="Ellipse_179"
                                          data-name="Ellipse 179"
                                          cx="13"
                                          cy="13"
                                          r="13"
                                          transform="translate(2 2)"
                                          fill="#fff"
                                          className="fillwhite"
                                        />
                                        <path
                                          id="Icon_awesome-linkedin-in"
                                          data-name="Icon awesome-linkedin-in"
                                          d="M2.781,12.424H.205V4.13H2.781ZM1.492,3A1.5,1.5,0,1,1,2.983,1.492,1.5,1.5,0,0,1,1.492,3Zm10.929,9.426H9.851V8.386c0-.962-.019-2.2-1.339-2.2-1.339,0-1.544,1.045-1.544,2.127v4.107H4.394V4.13h2.47V5.261H6.9A2.706,2.706,0,0,1,9.338,3.922c2.607,0,3.086,1.717,3.086,3.946v4.556Z"
                                          transform="translate(8.788 8.789)"
                                          fill="#415385"
                                        />
                                      </svg>
                                    </a>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    {isLoading && isHome && clickedShareBtn === 0 ? (
                      <>
                        {[1, 2, 3].map((m) => {
                          return (
                            <ShimmerNotification key={`notify-${m}-shimmer`} />
                          );
                        })}
                      </>
                    ) : (
                      <div className="idSessionList">
                        <div className="events-body">
                          {events?.length === 0 || authBroker?.payload?.user?.access_type === 3 ? (
                            <table className="table table-bordered mt-3">
                              <tbody className="colr_blkk">
                                <tr className="nodatafounds">
                                  <td
                                    className="text-center border-0"
                                    colSpan="7"
                                  >
                                    <section className="error-box p-0">
                                      <svg
                                        width="200"
                                        height="219"
                                        viewBox="0 0 400 419"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clip-path="url(#clip0_408_63632)">
                                          <path
                                            d="M154.734 418.558C240.191 418.558 309.467 406.32 309.467 391.223C309.467 376.126 240.191 363.887 154.734 363.887C69.2766 363.887 0 376.126 0 391.223C0 406.32 69.2766 418.558 154.734 418.558Z"
                                            fill="#EAECF0"
                                          />
                                          <path
                                            d="M248.777 302.445C332.295 302.445 400 234.74 400 151.223C400 67.7046 332.295 0 248.777 0C165.26 0 97.5549 67.7046 97.5549 151.223C97.5549 234.74 165.26 302.445 248.777 302.445Z"
                                            fill="#EAECF0"
                                          />
                                          <path
                                            opacity="0.05"
                                            d="M248.778 276.061C317.724 276.061 373.617 220.169 373.617 151.222C373.617 82.2757 317.724 26.3833 248.778 26.3833C179.831 26.3833 123.938 82.2757 123.938 151.222C123.938 220.169 179.831 276.061 248.778 276.061Z"
                                            fill="black"
                                          />
                                          <path
                                            opacity="0.05"
                                            d="M248.777 253.539C305.285 253.539 351.094 207.731 351.094 151.223C351.094 94.7149 305.285 48.9062 248.777 48.9062C192.27 48.9062 146.461 94.7149 146.461 151.223C146.461 207.731 192.27 253.539 248.777 253.539Z"
                                            fill="black"
                                          />
                                          <path
                                            opacity="0.05"
                                            d="M248.777 224.582C289.293 224.582 322.137 191.738 322.137 151.223C322.137 110.708 289.293 77.8638 248.777 77.8638C208.262 77.8638 175.418 110.708 175.418 151.223C175.418 191.738 208.262 224.582 248.777 224.582Z"
                                            fill="black"
                                          />
                                          <path
                                            d="M98.8941 164.756C98.8941 164.756 87.005 198.222 92.2891 210.111C97.5731 222 105.94 233.449 105.94 233.449C105.94 233.449 102.857 166.958 98.8941 164.756Z"
                                            fill="#D0CDE1"
                                          />
                                          <path
                                            opacity="0.1"
                                            d="M98.8941 164.756C98.8941 164.756 87.005 198.222 92.2891 210.111C97.5731 222 105.94 233.449 105.94 233.449C105.94 233.449 102.857 166.958 98.8941 164.756Z"
                                            fill="black"
                                          />
                                          <path
                                            d="M107.261 242.256C107.261 242.256 106.38 250.622 105.94 251.062C105.499 251.503 106.38 252.383 105.94 253.704C105.499 255.025 105.059 256.787 105.94 257.227C106.82 257.667 101.096 296.417 101.096 296.417C101.096 296.417 87.005 314.911 92.7294 343.974L94.4908 373.476C94.4908 373.476 108.141 374.357 108.141 369.513C108.141 369.513 107.261 363.789 107.261 361.147C107.261 358.505 109.462 358.505 108.141 357.184C106.82 355.863 106.82 354.982 106.82 354.982C106.82 354.982 109.022 353.221 108.582 352.78C108.141 352.34 112.545 321.076 112.545 321.076C112.545 321.076 117.388 316.232 117.388 313.59V310.948C117.388 310.948 119.59 305.224 119.59 304.784C119.59 304.343 131.479 277.483 131.479 277.483L136.323 296.858L141.607 324.599C141.607 324.599 144.249 349.698 149.533 359.386C149.533 359.386 158.78 391.09 158.78 390.209C158.78 389.329 174.192 387.127 173.752 383.164C173.311 379.201 164.504 323.718 164.504 323.718L166.706 241.375L107.261 242.256Z"
                                            fill="#2F2E41"
                                          />
                                          <path
                                            d="M95.3715 371.274C95.3715 371.274 83.4823 394.612 91.4084 395.493C99.3345 396.374 102.417 396.374 105.94 392.851C107.865 390.925 111.765 388.341 114.905 386.394C116.766 385.259 118.269 383.623 119.242 381.673C120.215 379.723 120.619 377.538 120.407 375.369C120.175 373.215 119.37 371.439 117.388 371.274C112.104 370.834 105.94 365.99 105.94 365.99L95.3715 371.274Z"
                                            fill="#2F2E41"
                                          />
                                          <path
                                            d="M160.982 388.448C160.982 388.448 149.093 411.786 157.019 412.666C164.945 413.547 168.027 413.547 171.55 410.024C173.476 408.098 177.376 405.514 180.516 403.568C182.376 402.433 183.879 400.796 184.852 398.846C185.825 396.896 186.229 394.711 186.017 392.542C185.785 390.388 184.98 388.613 182.999 388.448C177.715 388.007 171.55 383.164 171.55 383.164L160.982 388.448Z"
                                            fill="#2F2E41"
                                          />
                                          <path
                                            d="M148.416 126.564C158.639 126.564 166.926 118.277 166.926 108.054C166.926 97.8312 158.639 89.5439 148.416 89.5439C138.193 89.5439 129.906 97.8312 129.906 108.054C129.906 118.277 138.193 126.564 148.416 126.564Z"
                                            fill="#FFB8B8"
                                          />
                                          <path
                                            d="M136.517 114.136C136.517 114.136 123.295 138.463 122.238 138.463C121.18 138.463 146.036 146.396 146.036 146.396C146.036 146.396 152.912 123.126 153.969 121.011L136.517 114.136Z"
                                            fill="#FFB8B8"
                                          />
                                          <path
                                            d="M156.799 140.757C156.799 140.757 130.378 126.226 127.736 126.667C125.094 127.107 96.9127 151.766 97.353 161.894C97.7933 172.021 101.316 188.754 101.316 188.754C101.316 188.754 102.637 235.43 105.279 235.87C107.921 236.311 104.839 244.237 105.719 244.237C106.6 244.237 167.367 244.237 167.807 242.916C168.247 241.595 156.799 140.757 156.799 140.757Z"
                                            fill="#D0CDE1"
                                          />
                                          <path
                                            d="M171.55 245.338C171.55 245.338 179.916 270.878 172.871 269.997C165.826 269.116 162.743 247.98 162.743 247.98L171.55 245.338Z"
                                            fill="#FFB8B8"
                                          />
                                          <path
                                            d="M149.093 139.216C149.093 139.216 132.8 142.739 135.442 164.756C138.084 186.773 142.928 208.79 142.928 208.79L159.22 244.457L160.982 251.062L172.871 247.98L164.064 196.901C164.064 196.901 160.982 142.299 157.019 140.537C154.52 139.472 151.802 139.019 149.093 139.216Z"
                                            fill="#D0CDE1"
                                          />
                                          <path
                                            opacity="0.1"
                                            d="M139.185 208.13L159.441 244.237L142.375 206.189L139.185 208.13Z"
                                            fill="black"
                                          />
                                          <path
                                            d="M166.844 102.604L166.906 101.189L169.719 101.889C169.689 101.435 169.561 100.993 169.343 100.594C169.126 100.194 168.824 99.8463 168.459 99.5746L171.456 99.4071C168.941 95.833 165.727 92.8058 162.01 90.5083C158.292 88.2108 154.148 86.6906 149.826 86.0396C143.343 85.0999 136.124 86.4597 131.678 91.2712C129.522 93.605 128.167 96.5728 127.203 99.6006C125.428 105.177 125.066 111.825 128.768 116.358C132.53 120.965 139.101 121.867 145.022 122.437C147.105 122.638 149.288 122.825 151.218 122.016C151.433 119.802 151.15 117.568 150.389 115.477C150.072 114.83 149.92 114.115 149.948 113.395C150.211 111.633 152.561 111.19 154.325 111.428C156.09 111.666 158.213 112.03 159.372 110.678C160.171 109.747 160.124 108.391 160.23 107.169C160.518 103.842 166.814 103.301 166.844 102.604Z"
                                            fill="#2F2E41"
                                          />
                                          <g id="erropath">
                                            <path
                                              d="M280.376 394.984C292.288 394.984 301.944 385.328 301.944 373.417C301.944 361.506 292.288 351.85 280.376 351.85C268.465 351.85 258.809 361.506 258.809 373.417C258.809 385.328 268.465 394.984 280.376 394.984Z"
                                              fill="#415385"
                                            />
                                            <path
                                              d="M27.0847 387.461C38.9961 387.461 48.6521 377.805 48.6521 365.894C48.6521 353.982 38.9961 344.326 27.0847 344.326C15.1734 344.326 5.51733 353.982 5.51733 365.894C5.51733 377.805 15.1734 387.461 27.0847 387.461Z"
                                              fill="#415385"
                                            />
                                            <path
                                              d="M27.0847 352.853C35.672 352.853 42.6333 345.891 42.6333 337.304C42.6333 328.717 35.672 321.755 27.0847 321.755C18.4975 321.755 11.5361 328.717 11.5361 337.304C11.5361 345.891 18.4975 352.853 27.0847 352.853Z"
                                              fill="#415385"
                                            />
                                            <path
                                              d="M27.0845 324.263C33.1787 324.263 38.119 319.323 38.119 313.229C38.119 307.135 33.1787 302.194 27.0845 302.194C20.9904 302.194 16.05 307.135 16.05 313.229C16.05 319.323 20.9904 324.263 27.0845 324.263Z"
                                              fill="#415385"
                                            />
                                          </g>
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_408_63632">
                                            <rect
                                              width="400"
                                              height="418.558"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      <div className="error-msgs-cal">
                                        {/* {isLive?"No ongoing sessions":`No sessions are scheduled ${selectedTab === "today"
                                          ? "for today"
                                          : selectedTab === "tomorrow"
                                            ? "for tomorrow"
                                            : "in this week"
                                        }`} */}
                                        {authBroker?.payload?.user?.access_type === 3?t(
                                          "This content is not available in your current subscription, please contact to Halifax Sales AI support team."
                                        ):t(
                                          "Currently, no sessions available for you."
                                        )}
                                      </div>
                                    </section>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          ) : (
                            events?.map((item, i) => {
                              return (
                                <div
                                  className={
                                    i === selectedSessionPos
                                      ? "events-section active"
                                      : "events-section"
                                  }
                                  onClick={() => {
                                    setSelectedSessionPos(i);
                                    setSelectedSession(item);
                                    setSelectedSessionFromHome(item);
                                    setTimeout(() => {
                                      if (
                                        document.getElementById(
                                          "idDetailScreen"
                                        ) != null
                                      ) {
                                        if (
                                          isHome &&
                                          document.getElementById(
                                            "idHomeCalendar"
                                          ) !== null
                                        ) {
                                          document
                                            .getElementById("idHomeCalendar")
                                            .scrollIntoView();
                                        } else {
                                          document
                                            .getElementById("idDetailScreen")
                                            .scrollIntoView();
                                        }
                                      }
                                    }, 100);
                                  }}
                                >
                                  <div className="date-box">
                                    <div className="text-frame">
                                      <span className="number-2">
                                        {moment(item?.start).format("DD")}
                                      </span>
                                      <span className="month-oct">
                                        {moment(item?.start).format("MMM")}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="events-title-box">
                                    <div className="events-tilte">
                                      {item?.title}{" "}
                                      {item?.kickoff_session === "1" &&
                                      !isEvents
                                        ? `(Kickoff Session)`
                                        : ""}
                                    </div>
                                    <div className="date-box-events">
                                      {moment(item?.start).format(
                                        "ddd, h:mm A"
                                      )}{" "}
                                      {`(${item.userTimezone})`} |{" "}
                                      {isMyCoaching
                                        ? "Online"
                                        : !isEvents
                                        ? capitalizeFirstLetter(
                                            item.sessionMode
                                          )
                                        : setDeliveryMode(item)}
                                      {/* {setDeliveryMode(item)} */}
                                    </div>
                                  </div>
                                  <div className="events-img">
                                    <img
                                      src={
                                        !_.isEmpty(
                                          item?.marketting_event_thumbnail
                                        )
                                          ? item?.marketting_event_thumbnail
                                          : "/images/event-image.png"
                                      }
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-xl-6">
              {authBroker?.payload?.user?.access_type !== 3 && <EventSessionDetailComponent
                selectedSession={selectedSession}
                renderButton={isGuest ? renderJoinUs : renderButton}
                renderViewMore={renderViewMore}
                renderCoachingButtons={renderCoachingButtons}
                setDeliveryMode={setDeliveryMode}
                setIsLoading={setIsLoading}
                setClickedShareBtn={setClickedShareBtn}
                setClickDetailShareBtn={setClickDetailShareBtn}
                isLearn={isLearn}
                isLive={isLive}
                isGuest={isGuest}
                isEvents={isEvents}
                isCoaching={isCoaching}
                isMyCoaching={isMyCoaching}
              />}
            </div>
          </div>
        </div>
      </section>
      <CartPopUpComponent
        isOpen={isOpen}
        productData={headerProdData}
        closeAction={() => setIsOpen(false)}
        isSubscription={false}
        setMainPageLoading={setIsLoading}
      />
      {confirmModal ? (
        <ConfirmModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg}
          isConfirm={isConfirm}
          confirmId={sessionDataForModal}
          confirmAction={
            clickedItem === 2
              ? cancelSession
              : clickedItem === 3
              ? () => {
                  setConfirmModal(false); // Close confirm modal
                  openSlotModalBooking(); // Open SlotModalBooking
                }
              : clickedItem === 4
              ? () => {
                  setConfirmModal(false); // Close confirm modal
                  setShow4HourRescheduleModal(true);
                }: proceedToRegister
          }
          isRightIcon={!isConfirm}
          clickedItem={clickedItem}
          noAction={() => {}}
        />
      ) : (
        ""
      )}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="custom-modal"
        size="lg"
        centered
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="coach-detail-sec p-4">
          <div className="de text-center">
            {sessionModal && (
              <SlotBookingModal
                sessionModal={sessionModal}
                setSessionModal={setSessionModal}
                coachId={selectedCoachId}
                setIsLoading={setIsLoading}
                productTitle={productTitle}
                productId={productId}
                displayName={displayName}
                rescheduleFlag={rescheduleFlag}
                onCloseModal={() => setShow(false)}
                setConfirmModal={setConfirmModal}
                setShowModalMsg={setShowModalMsg}
                showCancel={true}
                setShow={setShow}
                setCongratsModal={setCongratsModal}
                sessionId={sessionId}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Four8HourRescheduleModal
        show={show4HourRescheduleModal} 
        setShow={setShow4HourRescheduleModal}
        coachId={selectedCoachId}
        productTitle={productTitle}
        productId={productId}
        hour  = {selectedHour}
        callFunc={callFunc}
       />
      <BookingCongratsModal
          show={congratsModal}
          setShow={setCongratsModal}
          slotInfo={""}
          bookingRequestMsg={false}
          showRescheduleMsg={true}
        />
    </>
  );
};

export default EventsCalendar;
